{
  "$comment": "THE release notes source. Newest entry first. RELEASE_NOTES.md is generated from this file (npm run release-notes:write); the app's What's new sheet reads it; the OTA workflow uses the newest entry's en-US title as its update message. en-GB and en-AU fall back to en-US. See docs/operations/RELEASING.md.",
  "entries": [
    {
      "id": "2026-11-04-esg-certificates-in-one-place",
      "capability": "capabilities.esg",
      "date": "2026-11-04",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "ESG: certificates in one place, and a clearer ESG tab",
        "ar": "ESG: الشهادات في مكان واحد وتبويب ESG أوضح",
        "de-DE": "ESG: Ausweise an einem Ort und ein klarerer ESG-Tab",
        "fr-FR": "ESG : les certificats au même endroit et un onglet ESG plus clair",
        "es-ES": "ESG: certificados en un solo lugar y una pestaña ESG más clara"
      },
      "items": {
        "en-US": [
          "An EPC or DEC is now kept once, under Documents. Upload it and the AI reads the rating, score, reference and dates; the valid-until date uses the date picker. The ESG tab shows it with Open certificate and Edit, and there is one set of reminders.",
          "Sites have their own Documents tab for the building's certificates.",
          "The ESG tab now matches the design: year-on-year figures, a monthly chart against last year, where the carbon comes from, F-gas leak checks with Book leak check, a leak log, four social and governance tiles, and Export ESG CSV and Share ESG report. Two columns on the web and tablets.",
          "Floor area has moved to the site's Details (set it on Edit site), and the refrigerant gas is read from the asset's Details."
        ],
        "ar": [
          "تُحفظ شهادة EPC أو DEC الآن مرة واحدة ضمن المستندات. ارفعها فيقرأ الذكاء الاصطناعي التصنيف والدرجة والمرجع والتواريخ، ويُختار تاريخ الصلاحية من منتقي التاريخ. يعرضها تبويب ESG مع فتح الشهادة وتعديل، وهناك مجموعة تذكيرات واحدة.",
          "للمواقع الآن تبويب مستندات خاص بها لشهادات المبنى.",
          "يطابق تبويب ESG التصميم الآن: أرقام مقارنة بالعام السابق، ورسم شهري مقابل العام الماضي، ومن أين يأتي الكربون، وفحوص تسرّب الغازات المفلورة مع حجز فحص تسرّب، وسجل تسرّب، وأربع بطاقات اجتماعية وحوكمة، وتصدير ESG بصيغة CSV ومشاركة تقرير ESG. عمودان على الويب والأجهزة اللوحية.",
          "انتقلت المساحة إلى تفاصيل الموقع (أدخلها في تعديل الموقع)، ويُقرأ غاز التبريد من تفاصيل الأصل."
        ],
        "de-DE": [
          "Ein EPC oder DEC wird jetzt einmal unter Dokumente abgelegt. Laden Sie ihn hoch, und die KI liest Klasse, Punktzahl, Nummer und Daten; das Gültig-bis-Datum nutzt die Datumsauswahl. Der ESG-Tab zeigt ihn mit „Ausweis öffnen“ und „Bearbeiten“, und es gibt nur eine Reihe von Erinnerungen.",
          "Standorte haben einen eigenen Tab Dokumente für die Ausweise des Gebäudes.",
          "Der ESG-Tab entspricht jetzt dem Entwurf: Vorjahresvergleich, ein Monatsdiagramm gegen das Vorjahr, woher das CO₂ kommt, F-Gas-Dichtheitsprüfungen mit „Dichtheitsprüfung buchen“, ein Leckprotokoll, vier Kacheln zu Sozialem und Governance sowie „ESG als CSV exportieren“ und „ESG-Bericht teilen“. Zwei Spalten im Web und auf Tablets.",
          "Die Fläche ist in die Standortdetails gewandert (unter „Standort bearbeiten“ eintragen), und das Kältemittel wird aus den Anlagendetails gelesen."
        ],
        "fr-FR": [
          "Un EPC ou un DEC est désormais classé une seule fois, dans Documents. Importez-le et l’IA lit la classe, la note, la référence et les dates ; la date de fin de validité utilise le sélecteur de date. L’onglet ESG l’affiche avec Ouvrir le certificat et Modifier, et il n’y a plus qu’une série de rappels.",
          "Les sites ont leur propre onglet Documents pour les certificats du bâtiment.",
          "L’onglet ESG suit maintenant la maquette : chiffres comparés à l’an dernier, graphique mensuel face à l’an dernier, d’où vient le carbone, contrôles d’étanchéité avec Planifier le contrôle, journal des fuites, quatre tuiles social et gouvernance, Exporter le CSV ESG et Partager le rapport ESG. Deux colonnes sur le web et les tablettes.",
          "La surface est passée dans les détails du site (à saisir dans Modifier le site), et le fluide frigorigène est lu dans les détails de l’équipement."
        ],
        "es-ES": [
          "Un EPC o DEC se guarda ahora una sola vez, en Documentos. Súbalo y la IA lee la calificación, la puntuación, la referencia y las fechas; la fecha de validez usa el selector de fecha. La pestaña ESG lo muestra con Abrir certificado y Editar, y hay un solo juego de recordatorios.",
          "Las ubicaciones tienen su propia pestaña Documentos para los certificados del edificio.",
          "La pestaña ESG sigue ahora el diseño: cifras frente al año anterior, un gráfico mensual frente al año pasado, de dónde viene el carbono, controles de fugas con Programar control de fugas, un registro de fugas, cuatro mosaicos sociales y de gobernanza, y Exportar CSV de ESG y Compartir informe ESG. Dos columnas en la web y en tabletas.",
          "La superficie ha pasado a los detalles de la ubicación (indíquela en Editar ubicación) y el gas refrigerante se lee de los detalles del activo."
        ]
      }
    },
    {
      "id": "2026-11-03-inspection-work-path",
      "capability": "capabilities.contractor_inspections",
      "date": "2026-11-03",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Choose who does a new inspection",
        "ar": "اختر من يجري الفحص الجديد",
        "de-DE": "Wählen Sie, wer eine neue Inspektion durchführt",
        "fr-FR": "Choisissez qui réalise une nouvelle inspection",
        "es-ES": "Elija quién hace una nueva inspección"
      },
      "items": {
        "en-US": [
          "A new inspection has a Work path, like a job: Our team or A contractor. Pick the contractor and they get the inspection, or the dated visit and its repeats.",
          "The contractor finds the visit in their My work and starts it there with your checklist. You approve it as usual."
        ],
        "ar": [
          "للفحص الجديد مسار عمل، مثل المهمة: فريقنا أو مقاول. اختر المقاول ليحصل على الفحص، أو على الزيارة المجدولة وتكراراتها.",
          "يجد المقاول الزيارة في عملي ويبدؤها من هناك بقائمة التحقق الخاصة بك. وتعتمدها أنت كالمعتاد."
        ],
        "de-DE": [
          "Eine neue Inspektion hat einen Arbeitsweg wie ein Auftrag: Unser Team oder Ein Auftragnehmer. Wählen Sie den Auftragnehmer, und er erhält die Inspektion oder den geplanten Termin samt Wiederholungen.",
          "Der Auftragnehmer findet den Termin in Meine Arbeit und startet ihn dort mit Ihrer Checkliste. Sie geben ihn wie gewohnt frei."
        ],
        "fr-FR": [
          "Une nouvelle inspection a un circuit de travail, comme une intervention : Notre équipe ou Un prestataire. Choisissez le prestataire : il reçoit l'inspection, ou la visite planifiée et ses répétitions.",
          "Le prestataire trouve la visite dans Mon travail et la démarre avec votre checklist. Vous la validez comme d'habitude."
        ],
        "es-ES": [
          "Una nueva inspección tiene una vía de trabajo, como un trabajo: Nuestro equipo o Un contratista. Elija el contratista y recibirá la inspección, o la visita programada y sus repeticiones.",
          "El contratista encuentra la visita en Mi trabajo y la inicia allí con su lista de comprobación. Usted la aprueba como siempre."
        ]
      }
    },
    {
      "id": "2026-11-03-esg-add-on",
      "capability": "capabilities.esg",
      "date": "2026-11-03",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "ESG and sustainability, as an add-on",
        "ar": "ESG والاستدامة، كإضافة",
        "de-DE": "ESG und Nachhaltigkeit als Zusatzmodul",
        "fr-FR": "ESG et développement durable, en option",
        "es-ES": "ESG y sostenibilidad, como complemento"
      },
      "items": {
        "en-US": [
          "Assets and sites have an ESG tab: energy, carbon and water for the last 12 months from your meter readings, with energy per m² once a site has its floor area.",
          "Record refrigerant on cooling and heat pump assets: the app works out the F-gas leak-check interval and plans the check for you.",
          "Add energy certificates with their rating and expiry date. Admins are reminded before they run out, and a let building below E is flagged.",
          "Write it up: the AI writes a short ESG summary for a manager, landlord or investor using only your figures. Insights, Asset 360, the assistant, the API and Power BI include ESG too.",
          "ESG is an add-on with a free trial. Your admin decides which plans include it."
        ],
        "ar": [
          "للأصول والمواقع تبويب ESG: الطاقة والكربون والمياه لآخر 12 شهرًا من قراءات العدادات، والطاقة لكل م² بعد إدخال مساحة الموقع.",
          "سجّل غاز التبريد على أصول التبريد والمضخات الحرارية: يحسب التطبيق فترة فحص تسرب الغازات المفلورة ويخطط الفحص لك.",
          "أضف شهادات الطاقة مع تصنيفها وتاريخ انتهائها. يُذكَّر المسؤولون قبل انتهائها، ويُنبَّه على أي مبنى مؤجر أقل من E.",
          "اكتبه: يكتب الذكاء الاصطناعي ملخص ESG قصيرًا لمدير أو مالك أو مستثمر من أرقامك فقط. وتشمل الرؤى وAsset 360 والمساعد وواجهة البرمجة وPower BI بيانات ESG أيضًا.",
          "ESG إضافة مع تجربة مجانية. يحدد المسؤول الخطط التي تتضمنها."
        ],
        "de-DE": [
          "Assets und Standorte haben einen Tab ESG: Energie, CO2 und Wasser der letzten 12 Monate aus Ihren Zählerständen, mit Energie pro m², sobald ein Standort seine Fläche hat.",
          "Erfassen Sie Kältemittel an Kälte- und Wärmepumpenanlagen: Die App berechnet das Intervall der F-Gas-Dichtheitsprüfung und plant die Prüfung für Sie.",
          "Fügen Sie Energieausweise mit Klasse und Ablaufdatum hinzu. Admins werden vor Ablauf erinnert, und ein vermietetes Gebäude unter E wird markiert.",
          "Zusammenfassen lassen: Die KI schreibt eine kurze ESG-Zusammenfassung für Manager, Vermieter oder Investoren, nur aus Ihren Zahlen. Analysen, Asset 360, der Assistent, die API und Power BI enthalten ESG ebenfalls.",
          "ESG ist ein Zusatzmodul mit kostenloser Testphase. Ihr Admin entscheidet, welche Tarife es enthalten."
        ],
        "fr-FR": [
          "Les actifs et les sites ont un onglet ESG : énergie, carbone et eau des 12 derniers mois à partir de vos relevés, avec l’énergie par m² dès qu’un site a sa surface.",
          "Saisissez le fluide frigorigène des équipements de froid et des pompes à chaleur : l’app calcule la fréquence du contrôle d’étanchéité et le planifie pour vous.",
          "Ajoutez les diagnostics énergétiques avec leur classe et leur date de fin. Les admins sont prévenus avant l’échéance, et un bâtiment loué sous E est signalé.",
          "Faire rédiger : l’IA rédige un court résumé ESG pour un gestionnaire, un bailleur ou un investisseur, uniquement avec vos chiffres. Analyses, Asset 360, l’assistant, l’API et Power BI incluent aussi l’ESG.",
          "L’ESG est une option avec un essai gratuit. Votre admin décide des offres qui l’incluent."
        ],
        "es-ES": [
          "Los activos y sedes tienen una pestaña ESG: energía, carbono y agua de los últimos 12 meses a partir de sus lecturas, con energía por m² cuando la sede tiene su superficie.",
          "Registre el refrigerante de equipos de frío y bombas de calor: la app calcula cada cuánto toca el control de fugas de gases fluorados y lo planifica por usted.",
          "Añada certificados energéticos con su calificación y fecha de caducidad. Se avisa a los administradores antes de que caduquen y se marca un edificio alquilado por debajo de E.",
          "Redáctelo: la IA escribe un breve resumen ESG para un gestor, propietario o inversor solo con sus cifras. Análisis, Asset 360, el asistente, la API y Power BI también incluyen ESG.",
          "ESG es un complemento con prueba gratuita. Su administrador decide qué planes lo incluyen."
        ]
      }
    },
    {
      "id": "2026-11-02-fewer-gaps-in-the-field",
      "date": "2026-11-02",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Start inspections offline, and more",
        "ar": "ابدأ الفحوص دون اتصال، والمزيد",
        "de-DE": "Prüfungen offline starten und mehr",
        "fr-FR": "Démarrez des inspections hors ligne, et plus",
        "es-ES": "Empiece inspecciones sin conexión, y más"
      },
      "items": {
        "en-US": [
          "You can start a new inspection with no signal on an asset your device has opened before. It is sent when you are back online.",
          "Jobs from findings suggest the asset's own contractor in Who, when it has one.",
          "Contractor work is grouped by client, and a contractor running your inspection sees the asset it is on.",
          "The Reports tab on an asset or site also lists its saved Asset 360 or Site 360 versions."
        ],
        "ar": [
          "يمكنك بدء فحص جديد دون إشارة على أصل فتحه جهازك من قبل. ويُرسل عند عودتك متصلًا.",
          "تقترح الأعمال الناتجة عن الملاحظات مقاول الأصل نفسه في خانة «من»، إن وُجد.",
          "تُجمَّع أعمال المقاول حسب العميل، ويرى المقاول الذي ينفذ فحصك الأصل الذي يخصه.",
          "تعرض علامة التبويب «التقارير» في الأصل أو الموقع أيضًا إصدارات Asset 360 أو Site 360 المحفوظة."
        ],
        "de-DE": [
          "Sie können ohne Empfang eine neue Prüfung an einem Asset starten, das Ihr Gerät schon einmal geöffnet hat. Sie wird gesendet, sobald Sie wieder online sind.",
          "Aufträge aus Befunden schlagen unter „Wer“ den Auftragnehmer des Assets vor, wenn es einen hat.",
          "Auftragsarbeit ist nach Kunden gruppiert, und ein Auftragnehmer, der Ihre Prüfung durchführt, sieht das zugehörige Asset.",
          "Der Tab „Berichte“ eines Assets oder Standorts listet auch die gespeicherten Versionen von Asset 360 oder Site 360."
        ],
        "fr-FR": [
          "Vous pouvez démarrer une nouvelle inspection sans réseau sur un actif déjà ouvert sur votre appareil. Elle est envoyée à votre retour en ligne.",
          "Les interventions issues des constats proposent le prestataire de l’actif dans « Qui », s’il en a un.",
          "Les travaux sous-traités sont regroupés par client, et un prestataire qui réalise votre inspection voit l’actif concerné.",
          "L’onglet Rapports d’un actif ou d’un site liste aussi ses versions Asset 360 ou Site 360 enregistrées."
        ],
        "es-ES": [
          "Puede empezar una inspección nueva sin cobertura en un activo que su dispositivo ya abrió. Se envía cuando vuelve a tener conexión.",
          "Las órdenes creadas a partir de hallazgos proponen al contratista del activo en «Quién», si lo tiene.",
          "El trabajo como contratista se agrupa por cliente, y un contratista que realiza su inspección ve el activo correspondiente.",
          "La pestaña Informes de un activo o sitio también muestra sus versiones guardadas de Asset 360 o Site 360."
        ]
      }
    },
    {
      "id": "2026-11-02-contractors-run-inspections",
      "date": "2026-11-02",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Give an inspection to a contractor",
        "ar": "أسند الفحص إلى مقاول",
        "de-DE": "Eine Inspektion an einen Auftragnehmer geben",
        "fr-FR": "Confiez une inspection à un prestataire",
        "es-ES": "Asigne una inspección a un contratista"
      },
      "items": {
        "en-US": [
          "On an inspection, Manage, Reassign now offers \"Assign to a contractor\". A contractor with an AssetWRX account finds it in their My work and runs the same checklist; you approve it as usual."
        ],
        "ar": [
          "في الفحص، يتيح الآن إدارة ثم إعادة الإسناد خيار «تعيين لمقاول». يجده المقاول الذي لديه حساب AssetWRX في عمله وينفذ قائمة الفحص نفسها؛ وتعتمده أنت كالمعتاد."
        ],
        "de-DE": [
          "Bei einer Inspektion bietet Verwalten, Neu zuweisen jetzt „Einem Auftragnehmer zuweisen“. Ein Auftragnehmer mit AssetWRX-Konto findet sie in seiner Arbeit und führt dieselbe Checkliste durch; Sie genehmigen sie wie gewohnt."
        ],
        "fr-FR": [
          "Sur une inspection, Gérer, Réaffecter propose maintenant « Attribuer à un prestataire ». Un prestataire ayant un compte AssetWRX la retrouve dans son travail et réalise la même liste de contrôle ; vous l'approuvez comme d'habitude."
        ],
        "es-ES": [
          "En una inspección, Gestionar, Reasignar ahora ofrece «Asignar a un contratista». Un contratista con cuenta de AssetWRX la encuentra en su trabajo y realiza la misma lista de verificación; usted la aprueba como siempre."
        ]
      }
    },
    {
      "id": "2026-11-02-sub-jobs",
      "capability": "capabilities.sub_jobs",
      "date": "2026-11-02",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Split a big job into sub-jobs",
        "ar": "قسّم المهمة الكبيرة إلى مهام فرعية",
        "de-DE": "Große Aufträge in Teilaufträge aufteilen",
        "fr-FR": "Découpez un gros travail en sous-travaux",
        "es-ES": "Divida un trabajo grande en subtrabajos"
      },
      "items": {
        "en-US": [
          "A job can hold sub-jobs, each with its own person or contractor and date. The job shows how many are done and what they cost so far, and waits until they are all finished. Turn on \"Do them in order\" to make each wait for the one before.",
          "From an inspection's findings, \"Make them one job with sub-jobs\" turns the findings into one job with a sub-job each. The completion report lists the sub-jobs, and the assistant can split a job for you."
        ],
        "ar": [
          "يمكن أن تضم المهمة مهام فرعية، لكل منها شخص أو مقاول وتاريخ. تعرض المهمة عدد ما اكتمل وتكلفته حتى الآن، وتنتظر حتى تكتمل جميعها. فعّل «تنفيذها بالترتيب» لتنتظر كل مهمة السابقة.",
          "من ملاحظات الفحص، يحوّل «اجعلها مهمة واحدة بمهام فرعية» الملاحظات إلى مهمة واحدة بمهمة فرعية لكل ملاحظة. يسرد تقرير الإكمال المهام الفرعية، ويمكن للمساعد تقسيم المهمة نيابةً عنك."
        ],
        "de-DE": [
          "Ein Auftrag kann Teilaufträge enthalten, jeder mit eigener Person oder eigenem Auftragnehmer und Datum. Der Auftrag zeigt, wie viele erledigt sind und was sie bisher kosten, und wartet, bis alle fertig sind. Mit „Der Reihe nach erledigen“ wartet jeder auf den vorherigen.",
          "Bei den Befunden einer Prüfung macht „Als einen Auftrag mit Teilaufträgen anlegen“ daraus einen Auftrag mit je einem Teilauftrag pro Befund. Der Abschlussbericht listet die Teilaufträge, und der Assistent kann einen Auftrag für Sie aufteilen."
        ],
        "fr-FR": [
          "Un travail peut contenir des sous-travaux, chacun avec sa personne ou son prestataire et sa date. Le travail affiche combien sont terminés et leur coût à ce jour, et attend qu'ils soient tous finis. Activez « Les faire dans l'ordre » pour que chacun attende le précédent.",
          "Depuis les constats d'une inspection, « En faire un seul travail avec des sous-travaux » crée un travail avec un sous-travail par constat. Le rapport de fin liste les sous-travaux, et l'assistant peut découper un travail pour vous."
        ],
        "es-ES": [
          "Un trabajo puede contener subtrabajos, cada uno con su persona o contratista y su fecha. El trabajo muestra cuántos están hechos y cuánto cuestan hasta ahora, y espera hasta que todos terminen. Active «Hacerlos en orden» para que cada uno espere al anterior.",
          "Desde los hallazgos de una inspección, «Convertirlos en un trabajo con subtrabajos» crea un trabajo con un subtrabajo por hallazgo. El informe de finalización lista los subtrabajos y el asistente puede dividir un trabajo por usted."
        ]
      }
    },
    {
      "id": "2026-11-02-finish-the-work-offline",
      "date": "2026-11-02",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Finish the work with no signal",
        "ar": "أنهِ العمل دون إشارة",
        "de-DE": "Arbeit ohne Empfang abschließen",
        "fr-FR": "Terminer le travail sans réseau",
        "es-ES": "Termine el trabajo sin cobertura"
      },
      "items": {
        "en-US": [
          "Start, pause and complete a job, and pause and complete an inspection, with no signal. It shows \"Saved locally\" and is sent when you are back online.",
          "When it is sent it is checked again; if someone else changed the job or inspection meanwhile, it shows \"Needs attention\" and Sync Center says why, instead of overwriting their change."
        ],
        "ar": [
          "ابدأ أمر العمل وأوقفه مؤقتًا وأكمله، وأوقف الفحص مؤقتًا وأكمله، دون إشارة. يظهر «محفوظ محليًا» ويُرسل عند عودتك متصلًا.",
          "عند الإرسال يُتحقق منه مجددًا؛ وإذا غيّر شخص آخر أمر العمل أو الفحص في الأثناء، يظهر «يحتاج إلى انتباه» ويشرح مركز المزامنة السبب، بدل الكتابة فوق تغييره."
        ],
        "de-DE": [
          "Aufträge ohne Empfang starten, pausieren und abschließen, Prüfungen pausieren und abschließen. Es zeigt „Lokal gespeichert“ und wird gesendet, sobald Sie wieder online sind.",
          "Beim Senden wird erneut geprüft; hat jemand anderes den Auftrag oder die Prüfung inzwischen geändert, zeigt es „Braucht Aufmerksamkeit“ und das Sync-Center nennt den Grund, statt die Änderung zu überschreiben."
        ],
        "fr-FR": [
          "Démarrez, mettez en pause et terminez une intervention, et mettez en pause et terminez une inspection, sans réseau. Elle affiche « Enregistré localement » et est envoyée à votre retour en ligne.",
          "À l'envoi, tout est vérifié à nouveau ; si quelqu'un d'autre a modifié l'intervention ou l'inspection entre-temps, elle affiche « Nécessite une attention » et le Centre de synchronisation explique pourquoi, au lieu d'écraser sa modification."
        ],
        "es-ES": [
          "Empiece, pause y complete una orden de trabajo, y pause y complete una inspección, sin cobertura. Muestra «Guardado localmente» y se envía cuando vuelve a tener conexión.",
          "Al enviarse se comprueba de nuevo; si otra persona cambió la orden o la inspección mientras tanto, muestra «Requiere atención» y el Centro de sincronización explica por qué, en lugar de sobrescribir su cambio."
        ]
      }
    },
    {
      "id": "2026-11-02-fewer-taps-for-inspections-and-jobs",
      "date": "2026-11-02",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Fewer taps for inspections and jobs",
        "ar": "نقرات أقل للفحوص والمهام",
        "de-DE": "Weniger Tipps für Prüfungen und Aufträge",
        "fr-FR": "Moins de gestes pour les inspections et les interventions",
        "es-ES": "Menos toques para inspecciones y órdenes de trabajo"
      },
      "items": {
        "en-US": [
          "One list turns findings into jobs: failed items and the repairs a client approved, each with who does it and when, created and assigned in one tap.",
          "Draft with AI is optional on that list and shows its credits first; the rule-built list stays the default.",
          "Completing a job is one page. If the job needs costs, a meter reading or a check, the button says Continue.",
          "A job of yours due today offers Accept and start or Accept and schedule.",
          "A scheduled inspection reminder opens on Start, so you are straight in; when you finish you go back to the list you came from.",
          "On a request, Create work is a short sheet with Who and When, and a case waiting on the customer can still be inspected or turned into work.",
          "If you also work as a contractor for other companies, Contractor work in the Work scope chip shows those jobs and quotes."
        ],
        "ar": [
          "قائمة واحدة تحوّل النتائج إلى مهام: البنود الفاشلة والإصلاحات التي وافق عليها العميل، مع من ينفذ ومتى، تُنشأ وتُعيَّن بنقرة واحدة.",
          "الصياغة بالذكاء الاصطناعي اختيارية في تلك القائمة وتعرض الأرصدة أولاً؛ وتبقى القائمة المبنية على القواعد هي الافتراضية.",
          "إكمال المهمة صفحة واحدة. إذا احتاجت المهمة إلى تكاليف أو قراءة عداد أو فحص، يصبح الزر «متابعة».",
          "المهمة المستحقة اليوم والمسندة إليك تعرض «قبول وبدء» أو «قبول وجدولة».",
          "تذكير الفحص المجدول يفتح على «ابدأ» فتدخل مباشرة، وعند الانتهاء تعود إلى القائمة التي بدأت منها.",
          "في الطلب، «إنشاء عمل» ورقة قصيرة فيها من ومتى، ويمكن فحص الحالة التي تنتظر العميل أو تحويلها إلى عمل.",
          "إذا كنت تعمل أيضًا مقاولًا لشركات أخرى، فإن «أعمال المقاول» في شريحة نطاق العمل تعرض تلك المهام وعروض الأسعار."
        ],
        "de-DE": [
          "Eine Liste macht aus Befunden Aufträge: nicht bestandene Punkte und vom Kunden freigegebene Reparaturen, jeweils mit wer und wann, in einem Tipp angelegt und zugewiesen.",
          "„Mit KI entwerfen“ ist auf dieser Liste optional und zeigt die Credits vorher; die regelbasierte Liste bleibt der Standard.",
          "Einen Auftrag abschließen ist eine Seite. Braucht er Kosten, einen Zählerstand oder eine Prüfung, heißt die Schaltfläche „Weiter“.",
          "Ein heute fälliger Auftrag für Sie bietet „Annehmen und starten“ oder „Annehmen und planen“.",
          "Die Erinnerung an eine geplante Prüfung öffnet mit „Starten“, und danach kehren Sie zur Liste zurück, von der Sie kamen.",
          "In einer Anfrage ist „Arbeit anlegen“ ein kurzes Blatt mit wer und wann, und ein Fall, der auf den Kunden wartet, kann trotzdem geprüft oder zu Arbeit werden.",
          "Wenn Sie auch als Auftragnehmer für andere Firmen arbeiten, zeigt „Auftragsarbeit“ im Bereichs-Chip unter Arbeit diese Aufträge und Angebote."
        ],
        "fr-FR": [
          "Une seule liste transforme les constats en interventions : points en échec et réparations approuvées par le client, chacune avec qui et quand, créées et attribuées en un geste.",
          "« Rédiger avec l'IA » est facultatif sur cette liste et affiche d'abord ses crédits ; la liste construite par règles reste celle par défaut.",
          "Terminer une intervention tient sur une page. Si elle demande des coûts, un relevé de compteur ou une vérification, le bouton indique « Continuer ».",
          "Une intervention qui vous est attribuée pour aujourd'hui propose « Accepter et démarrer » ou « Accepter et planifier ».",
          "Le rappel d'une inspection planifiée s'ouvre sur « Démarrer » ; à la fin, vous revenez à la liste d'où vous êtes parti.",
          "Sur une demande, « Créer un travail » est une courte fiche avec qui et quand, et un dossier en attente du client peut quand même être inspecté ou devenir un travail.",
          "Si vous travaillez aussi comme sous-traitant pour d'autres entreprises, « Travaux sous-traités » dans la puce de périmètre de Travail montre ces interventions et devis."
        ],
        "es-ES": [
          "Una sola lista convierte los hallazgos en órdenes de trabajo: puntos fallidos y reparaciones aprobadas por el cliente, cada una con quién y cuándo, creadas y asignadas con un toque.",
          "«Redactar con IA» es opcional en esa lista y muestra antes sus créditos; la lista basada en reglas sigue siendo la predeterminada.",
          "Completar una orden de trabajo es una sola página. Si necesita costes, una lectura de contador o una comprobación, el botón dice «Continuar».",
          "Una orden suya que vence hoy ofrece «Aceptar y empezar» o «Aceptar y programar».",
          "El recordatorio de una inspección programada se abre en «Empezar»; al terminar vuelve a la lista de la que vino.",
          "En una solicitud, «Crear trabajo» es una hoja corta con quién y cuándo, y un caso que espera al cliente se puede inspeccionar o convertir en trabajo igualmente.",
          "Si también trabaja como contratista para otras empresas, «Trabajo como contratista» en el chip de ámbito de Trabajo muestra esas órdenes y presupuestos."
        ]
      }
    },
    {
      "id": "2026-11-02-sign-off-in-fewer-steps",
      "date": "2026-11-02",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Sign off in fewer steps",
        "ar": "اعتماد بخطوات أقل",
        "de-DE": "Abzeichnen in weniger Schritten",
        "fr-FR": "Valider en moins d'étapes",
        "es-ES": "Dar conformidad en menos pasos"
      },
      "items": {
        "en-US": [
          "One word everywhere: approving an inspection and verifying a job are now both \"Sign off\", and finished work reads \"Signed off\".",
          "Sign off straight from the report: whoever signs off an inspection or a job sees Sign off and Send back at the top of its report.",
          "Clients sign off in three taps: the link in the email signs them in, suggested repairs start approved, and signing is signing off.",
          "Requesters sign off a finished job on its report, with the same page and signature as an inspection review.",
          "Review now lists what you can sign off; \"Everyone's\" shows the rest.",
          "Sharing a job report or an Asset 360 report uses the same screen words as sharing an inspection report.",
          "A Reports tab on every asset and site lists its inspection and job reports, and finished jobs in an asset's history open their report."
        ],
        "ar": [
          "كلمة واحدة في كل مكان: أصبحت الموافقة على الفحص والتحقق من المهمة كلاهما \"اعتماد\"، ويظهر العمل المنتهي \"معتمد\".",
          "اعتمد مباشرة من التقرير: يرى من يعتمد الفحص أو المهمة «اعتماد» و«إرجاع» أعلى التقرير.",
          "يعتمد العملاء بثلاث نقرات: الرابط في البريد يسجّل دخولهم، وتبدأ الإصلاحات المقترحة موافقًا عليها، والتوقيع هو الاعتماد.",
          "يعتمد مقدمو الطلبات المهمة المنتهية من تقريرها، بالصفحة والتوقيع نفسيهما كمراجعة الفحص.",
          "تعرض «مراجعة» الآن ما يمكنك اعتماده؛ و«الجميع» تعرض الباقي.",
          "مشاركة تقرير مهمة أو تقرير Asset 360 تستخدم كلمات الشاشة نفسها كمشاركة تقرير الفحص.",
          "علامة «التقارير» في كل أصل وموقع تعرض تقارير الفحص والمهام، والمهام المنتهية في سجل الأصل تفتح تقريرها."
        ],
        "de-DE": [
          "Ein Wort überall: Eine Inspektion genehmigen und einen Auftrag bestätigen heißt jetzt beides „Abzeichnen“, und fertige Arbeit zeigt „Abgezeichnet“.",
          "Direkt im Bericht abzeichnen: Wer eine Inspektion oder einen Auftrag abzeichnet, sieht oben im Bericht „Abzeichnen“ und „Zurückschicken“.",
          "Kunden zeichnen mit drei Tipps ab: Der Link in der E-Mail meldet sie an, vorgeschlagene Reparaturen sind bereits genehmigt, und Unterschreiben ist Abzeichnen.",
          "Anfragende zeichnen einen fertigen Auftrag in seinem Bericht ab, mit derselben Seite und Unterschrift wie bei einer Inspektionsprüfung.",
          "„Prüfung“ listet jetzt, was Sie abzeichnen können; „Alle“ zeigt den Rest.",
          "Einen Auftragsbericht oder Asset-360-Bericht teilen nutzt dieselben Wörter wie das Teilen eines Inspektionsberichts.",
          "Ein Tab „Berichte“ auf jeder Anlage und jedem Standort listet Inspektions- und Auftragsberichte, und fertige Aufträge im Verlauf einer Anlage öffnen ihren Bericht."
        ],
        "fr-FR": [
          "Un seul mot partout : approuver une inspection et vérifier une intervention, c'est désormais « Valider », et le travail terminé affiche « Validée ».",
          "Validez directement depuis le rapport : la personne qui valide une inspection ou une intervention voit « Valider » et « Renvoyer » en haut du rapport.",
          "Les clients valident en trois gestes : le lien de l'e-mail les connecte, les réparations proposées sont approuvées d'office, et signer, c'est valider.",
          "Les demandeurs valident une intervention terminée sur son rapport, avec la même page et la même signature qu'une revue d'inspection.",
          "« À valider » liste maintenant ce que vous pouvez valider ; « Tout le monde » montre le reste.",
          "Partager un rapport d'intervention ou un rapport Asset 360 utilise les mêmes mots que le partage d'un rapport d'inspection.",
          "Un onglet « Rapports » sur chaque actif et chaque site liste ses rapports d'inspection et d'intervention, et les interventions terminées dans l'historique d'un actif ouvrent leur rapport."
        ],
        "es-ES": [
          "Una sola palabra en todas partes: aprobar una inspección y verificar un trabajo ahora son «Dar conformidad», y el trabajo terminado muestra «Conforme».",
          "Dé conformidad desde el propio informe: quien la da a una inspección o un trabajo ve «Dar conformidad» y «Devolver» arriba del informe.",
          "Los clientes dan conformidad en tres toques: el enlace del correo inicia su sesión, las reparaciones propuestas ya vienen aprobadas y firmar es dar conformidad.",
          "Los solicitantes dan conformidad a un trabajo terminado en su informe, con la misma página y firma que la revisión de una inspección.",
          "«Revisión» muestra ahora lo que usted puede aprobar; «De todos» muestra el resto.",
          "Compartir un informe de trabajo o un informe Asset 360 usa las mismas palabras que compartir un informe de inspección.",
          "Una pestaña «Informes» en cada activo y sitio muestra sus informes de inspección y de trabajo, y los trabajos terminados en el historial de un activo abren su informe."
        ]
      }
    },
    {
      "id": "2026-11-02-jobs-and-inspections-small-fixes",
      "date": "2026-11-02",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Smoother jobs and reports",
        "ar": "وظائف وتقارير أكثر سلاسة",
        "de-DE": "Reibungslosere Aufträge und Berichte",
        "fr-FR": "Des travaux et des rapports plus fluides",
        "es-ES": "Trabajos e informes más fluidos"
      },
      "items": {
        "en-US": [
          "When someone asks to read a report you shared, you can now answer them: the ask shows in Work (Needs you and Review) and on the report itself.",
          "Awarding a quote is now a single step, so the job, the other quotes and the request always change together.",
          "On the web, the reviewer's buttons for completed work now read Sign off, Send back, Ask for photos, the same order as on the phone.",
          "Skipped jobs show \"Skipped\". Scanning an asset's code while signed out offers \"Report an issue\" only when that asset takes reports.",
          "Dragging a job on the board now uses the same stage the rest of the app shows."
        ],
        "ar": [
          "عندما يطلب أحدهم قراءة تقرير شاركته، يمكنك الآن الرد عليه: يظهر الطلب في العمل (يحتاج إليك ومراجعة) وفي التقرير نفسه.",
          "أصبح منح عرض السعر خطوة واحدة، فتتغير المهمة وعروض الأسعار الأخرى والطلب معًا دائمًا.",
          "على الويب، أصبحت أزرار المراجِع للعمل المكتمل بالترتيب: اعتماد، إعادة للتعديل، طلب صور، كما على الهاتف.",
          "تظهر المهام المتخطاة بعبارة \"تم التخطي\". وعند مسح رمز أصل دون تسجيل الدخول، لا يظهر \"الإبلاغ عن مشكلة\" إلا إذا كان الأصل يقبل البلاغات.",
          "سحب مهمة على اللوحة يعتمد الآن على المرحلة نفسها التي يعرضها باقي التطبيق."
        ],
        "de-DE": [
          "Wenn jemand darum bittet, einen von Ihnen geteilten Bericht zu lesen, können Sie jetzt antworten: Die Anfrage erscheint unter Arbeit (Braucht Sie und Prüfung) und im Bericht selbst.",
          "Ein Angebot zu vergeben ist jetzt ein einziger Schritt: Auftrag, übrige Angebote und Anfrage ändern sich immer gemeinsam.",
          "Im Web lauten die Prüfer-Schaltflächen für abgeschlossene Arbeit jetzt Abzeichnen, Zurückschicken, Fotos anfordern – dieselbe Reihenfolge wie auf dem Telefon.",
          "Ausgelassene Aufträge zeigen „Ausgelassen“. Wer den Code einer Anlage ohne Anmeldung scannt, sieht „Ein Problem melden“ nur, wenn die Anlage Meldungen annimmt.",
          "Das Ziehen eines Auftrags auf dem Board nutzt jetzt dieselbe Phase, die die übrige App anzeigt."
        ],
        "fr-FR": [
          "Quand quelqu’un demande à lire un rapport que vous avez partagé, vous pouvez désormais lui répondre : la demande apparaît dans Travaux (Besoin de vous et À valider) et sur le rapport lui-même.",
          "Attribuer un devis se fait désormais en une seule étape : le travail, les autres devis et la demande changent toujours ensemble.",
          "Sur le web, les boutons du réviseur pour un travail terminé sont désormais Valider, Renvoyer, Demander des photos, dans le même ordre que sur le téléphone.",
          "Les travaux ignorés affichent « Ignorée ». En scannant le code d’un actif sans être connecté, « Signaler un problème » n’apparaît que si l’actif accepte les signalements.",
          "Faire glisser un travail sur le tableau utilise désormais la même étape que le reste de l’application."
        ],
        "es-ES": [
          "Cuando alguien pide leer un informe que usted compartió, ahora puede responderle: la solicitud aparece en Trabajo (Requiere su atención y Revisión) y en el propio informe.",
          "Adjudicar un presupuesto es ahora un solo paso: el trabajo, los demás presupuestos y la solicitud cambian siempre a la vez.",
          "En la web, los botones del revisor para el trabajo terminado son ahora Dar conformidad, Devolver, Pedir fotos, en el mismo orden que en el teléfono.",
          "Los trabajos omitidos muestran «Omitido». Al escanear el código de un activo sin iniciar sesión, «Informar un problema» solo aparece si el activo acepta informes.",
          "Arrastrar un trabajo en el tablero usa ahora la misma etapa que muestra el resto de la aplicación."
        ]
      }
    },
    {
      "id": "2026-11-01-asset-360-compare-value-integrations",
      "date": "2026-11-01",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Asset 360 and Site 360: comparisons, value and integrations",
        "ar": "Asset 360 وSite 360: المقارنات والقيمة والتكاملات",
        "de-DE": "Asset 360 und Site 360: Vergleiche, Wert und Integrationen",
        "fr-FR": "Asset 360 et Site 360 : comparaisons, valeur et intégrations",
        "es-ES": "Asset 360 y Site 360: comparaciones, valor e integraciones"
      },
      "items": {
        "en-US": [
          "How it compares shows where an asset or site sits against similar ones in your workspace on compliance, condition, risk and right first time.",
          "Value and life: record the installed date, expected life and costs on the asset's Edit page. The report shows the life left, the values and the last year's spend, and suggests Plan the replacement when it is due. With Look online on, the AI version adds a market price with its sources.",
          "Ask the assistant how an asset compares or how a site is doing. The API, Power BI and MCP can now read Asset 360 and Site 360 when your edition includes them."
        ],
        "de-DE": [
          "„Im Vergleich“ zeigt, wo eine Anlage oder ein Standort gegenüber ähnlichen in Ihrem Arbeitsbereich steht: Compliance, Zustand, Risiko und „Beim ersten Mal richtig“.",
          "Wert und Lebensdauer: Tragen Sie auf der Bearbeitungsseite der Anlage Einbaudatum, erwartete Lebensdauer und Kosten ein. Der Bericht zeigt die verbleibende Lebensdauer, die Werte und die Ausgaben des letzten Jahres und schlägt „Ersatz planen“ vor, wenn es so weit ist. Mit „Online nachschlagen“ ergänzt die KI-Version einen Marktpreis mit Quellen.",
          "Fragen Sie den Assistenten, wie eine Anlage im Vergleich dasteht oder wie es einem Standort geht. API, Power BI und MCP lesen Asset 360 und Site 360 jetzt, wenn Ihre Edition sie enthält."
        ],
        "fr-FR": [
          "« En comparaison » montre où se situe un actif ou un site par rapport aux actifs ou sites similaires de votre espace : conformité, état, risque et réussite du premier coup.",
          "Valeur et durée de vie : saisissez la date d’installation, la durée de vie prévue et les coûts sur la page Modifier de l’actif. Le rapport indique la durée de vie restante, les valeurs et les dépenses de l’année écoulée, et propose « Planifier le remplacement » le moment venu. Avec la recherche en ligne activée, la version IA ajoute un prix de marché avec ses sources.",
          "Demandez à l’assistant comment un actif se compare ou comment va un site. L’API, Power BI et MCP lisent désormais Asset 360 et Site 360 lorsque votre édition les inclut."
        ],
        "es-ES": [
          "«Cómo se compara» muestra dónde se sitúa un activo o un sitio frente a otros similares de su espacio de trabajo: cumplimiento, estado, riesgo y bien a la primera.",
          "Valor y vida útil: registre la fecha de instalación, la vida útil prevista y los costes en la página Editar del activo. El informe muestra la vida restante, los valores y el gasto del último año, y sugiere «Planificar la sustitución» cuando toca. Con la búsqueda en línea activada, la versión de IA añade un precio de mercado con sus fuentes.",
          "Pregunte al asistente cómo se compara un activo o cómo va un sitio. La API, Power BI y MCP ya leen Asset 360 y Site 360 cuando su edición los incluye."
        ],
        "ar": [
          "يعرض «المقارنة» موقع الأصل أو الموقع مقارنةً بالأصول أو المواقع المشابهة في مساحة عملك: الامتثال والحالة والمخاطر والإنجاز من المرة الأولى.",
          "القيمة والعمر: سجّل تاريخ التركيب والعمر المتوقع والتكاليف في صفحة تعديل الأصل. يعرض التقرير العمر المتبقي والقيم وإنفاق العام الماضي، ويقترح «خطط للاستبدال» عند الحاجة. عند تفعيل البحث عبر الإنترنت تضيف نسخة الذكاء الاصطناعي سعر السوق مع مصادره.",
          "اسأل المساعد كيف يُقارن أصل ما أو كيف حال موقع ما. أصبح بإمكان واجهة API وPower BI وMCP قراءة Asset 360 وSite 360 عندما تتضمنها إصدارتك."
        ]
      }
    },
    {
      "id": "2026-11-01-asset-360-versions-sharing",
      "date": "2026-11-01",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Asset 360 and Site 360: versions and sharing",
        "ar": "Asset 360 وSite 360: الإصدارات والمشاركة",
        "de-DE": "Asset 360 und Site 360: Versionen und Teilen",
        "fr-FR": "Asset 360 et Site 360 : versions et partage",
        "es-ES": "Asset 360 y Site 360: versiones y compartir"
      },
      "items": {
        "en-US": [
          "Versions keeps every saved report exactly as it was. Save this version is free; open any version, or compare it with the one before.",
          "Share sends a version to a landlord, client or anyone else, like an inspection report. They see the cover and scorecard at once and sign in or create a free account to read the rest. See when they read it, send a newer version, or withdraw it.",
          "The PDF button is now Share. Download PDF and Download CSV are for whoever approves work on the asset (or any asset at the site)."
        ],
        "de-DE": [
          "Unter „Versionen“ bleibt jeder gespeicherte Bericht genau so, wie er war. „Diese Version speichern“ ist kostenlos; öffnen Sie jede Version oder vergleichen Sie sie mit der vorherigen.",
          "„Teilen“ sendet eine Version an Vermieter, Kunden oder andere, wie einen Inspektionsbericht. Deckblatt und Kennzahlen sind sofort sichtbar, der Rest nach Anmeldung oder mit einem kostenlosen Konto. Sie sehen, wann gelesen wurde, können eine neuere Version senden oder das Teilen zurückziehen.",
          "Die PDF-Schaltfläche heißt jetzt „Teilen“. „PDF herunterladen“ und „CSV herunterladen“ gibt es für die Personen, die Arbeiten an der Anlage (oder einer Anlage des Standorts) freigeben."
        ],
        "fr-FR": [
          "« Versions » garde chaque rapport enregistré tel qu’il était. « Enregistrer cette version » est gratuit ; ouvrez n’importe quelle version ou comparez-la à la précédente.",
          "« Partager » envoie une version à un bailleur, un client ou toute autre personne, comme un rapport d’inspection. La couverture et le tableau de bord sont visibles tout de suite, le reste après connexion ou création d’un compte gratuit. Voyez quand il a été lu, envoyez une version plus récente ou retirez le partage.",
          "Le bouton PDF devient « Partager ». « Télécharger le PDF » et « Télécharger le CSV » sont réservés aux personnes qui approuvent les travaux sur l’actif (ou sur un actif du site)."
        ],
        "es-ES": [
          "«Versiones» guarda cada informe tal como era. «Guardar esta versión» es gratis; abra cualquier versión o compárela con la anterior.",
          "«Compartir» envía una versión a un arrendador, un cliente o cualquier otra persona, como un informe de inspección. Ven la portada y el cuadro de mando al momento e inician sesión o crean una cuenta gratuita para leer el resto. Vea cuándo lo leyeron, envíe una versión más reciente o retírelo.",
          "El botón PDF ahora es «Compartir». «Descargar PDF» y «Descargar CSV» son para quien aprueba los trabajos del activo (o de cualquier activo del sitio)."
        ],
        "ar": [
          "يحفظ قسم «الإصدارات» كل تقرير محفوظ كما كان تمامًا. «حفظ هذا الإصدار» مجاني؛ افتح أي إصدار أو قارنه بالسابق.",
          "«مشاركة» يرسل إصدارًا إلى مؤجر أو عميل أو أي شخص آخر، مثل تقرير الفحص. يرى الغلاف وبطاقة الأداء فورًا، ثم يسجّل الدخول أو ينشئ حسابًا مجانيًا لقراءة الباقي. اعرف متى قرأه، أو أرسل إصدارًا أحدث، أو اسحب المشاركة.",
          "أصبح زر PDF الآن «مشاركة». «تنزيل PDF» و«تنزيل CSV» لمن يعتمد الأعمال على الأصل (أو على أي أصل في الموقع)."
        ]
      }
    },
    {
      "id": "2026-11-01-asset-360-site-360",
      "date": "2026-11-01",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Asset 360 and Site 360: one report, written for the person reading it",
        "ar": "Asset 360 وSite 360: تقرير واحد مكتوب لمن سيقرؤه",
        "de-DE": "Asset 360 und Site 360: ein Bericht, geschrieben für den Leser",
        "fr-FR": "Asset 360 et Site 360 : un rapport rédigé pour celui qui le lit",
        "es-ES": "Asset 360 y Site 360: un informe redactado para quien lo lee"
      },
      "items": {
        "en-US": [
          "The asset report is now Asset 360 and the site report is Site 360. Same buttons, new names: + then Asset 360 on an asset, + then Site 360 on a site.",
          "The report opens at once with a verdict, a scorecard, each topic with its chart, an action plan with buttons to raise the work, and a data quality score. This part is free.",
          "Pick who it is for (asset manager, client, landlord, site manager or investor) and tap Write the AI version. It waits in a short queue, you are told when it is ready, and credits are used only once it is written. Landlord and investor versions hide contractor names unless you turn that off.",
          "Admins can switch Asset 360 and Site 360 on or off for each edition in the Matrix. Reports written before today are still there under Earlier AI reports."
        ],
        "de-DE": [
          "Der Anlagenbericht heißt jetzt Asset 360 und der Standortbericht Site 360. Gleiche Schaltflächen, neue Namen: + und dann Asset 360 bei einer Anlage, + und dann Site 360 bei einem Standort.",
          "Der Bericht öffnet sich sofort mit Gesamturteil, Kennzahlen, jedem Thema mit Diagramm, einem Maßnahmenplan mit Schaltflächen zum Anlegen der Arbeit und einer Datenqualität. Dieser Teil ist kostenlos.",
          "Wählen Sie, für wen er ist (Asset Manager, Kunde, Vermieter, Standortleiter oder Investor), und tippen Sie auf „KI-Fassung schreiben“. Er wartet kurz in einer Warteschlange, Sie werden benachrichtigt, und Credits werden erst nach dem Schreiben verbraucht. Fassungen für Vermieter und Investor blenden Namen von Auftragnehmern aus, solange Sie das nicht ausschalten.",
          "Admins können Asset 360 und Site 360 in der Matrix für jede Edition ein- oder ausschalten. Frühere Berichte finden Sie weiterhin unter „Frühere KI-Berichte“."
        ],
        "fr-FR": [
          "Le rapport d’actif s’appelle désormais Asset 360 et le rapport de site Site 360. Mêmes boutons, nouveaux noms : + puis Asset 360 sur un actif, + puis Site 360 sur un site.",
          "Le rapport s’ouvre aussitôt avec un avis général, un tableau de bord, chaque sujet avec son graphique, un plan d’action avec des boutons pour lancer le travail et un score de qualité des données. Cette partie est gratuite.",
          "Choisissez pour qui il est (gestionnaire d’actifs, client, bailleur, responsable de site ou investisseur) et touchez « Rédiger la version IA ». Il attend dans une courte file, vous êtes prévenu quand il est prêt, et les crédits ne sont utilisés qu’une fois le rapport rédigé. Les versions bailleur et investisseur masquent le nom des prestataires, sauf si vous désactivez cette option.",
          "Les administrateurs peuvent activer ou désactiver Asset 360 et Site 360 pour chaque édition dans la matrice. Les rapports antérieurs restent disponibles sous « Anciens rapports IA »."
        ],
        "es-ES": [
          "El informe del activo ahora se llama Asset 360 y el del sitio, Site 360. Mismos botones, nombres nuevos: + y después Asset 360 en un activo, + y después Site 360 en un sitio.",
          "El informe se abre al momento con un veredicto, un cuadro de mando, cada tema con su gráfico, un plan de acción con botones para crear el trabajo y una puntuación de calidad de datos. Esta parte es gratuita.",
          "Elija para quién es (gestor de activos, cliente, arrendador, responsable de sitio o inversor) y toque «Redactar la versión con IA». Espera en una cola breve, le avisamos cuando esté listo y los créditos se usan solo cuando está redactado. Las versiones para arrendador e inversor ocultan los nombres de los contratistas, salvo que lo desactive.",
          "Los administradores pueden activar o desactivar Asset 360 y Site 360 en cada edición desde la matriz. Los informes anteriores siguen en «Informes de IA anteriores»."
        ],
        "ar": [
          "أصبح تقرير الأصل اسمه Asset 360 وتقرير الموقع Site 360. الأزرار نفسها بأسماء جديدة: + ثم Asset 360 في الأصل، و+ ثم Site 360 في الموقع.",
          "يُفتح التقرير فورًا بحكم عام وبطاقة أداء وكل موضوع مع مخططه وخطة عمل بأزرار لإنشاء العمل ودرجة لجودة البيانات. هذا الجزء مجاني.",
          "اختر لمن هو (مدير الأصول أو العميل أو المؤجر أو مدير الموقع أو المستثمر) واضغط «كتابة نسخة الذكاء الاصطناعي». ينتظر في قائمة قصيرة، وتُبلَّغ عندما يصبح جاهزًا، ولا يُستهلك الرصيد إلا بعد كتابته. تُخفي نسختا المؤجر والمستثمر أسماء المقاولين ما لم توقف ذلك.",
          "يمكن للمسؤولين تشغيل Asset 360 وSite 360 أو إيقافهما لكل إصدار من المصفوفة. التقارير السابقة ما زالت موجودة تحت «تقارير الذكاء الاصطناعي السابقة»."
        ]
      }
    },
    {
      "id": "2026-11-01-switched-off-features-show-upgrade",
      "date": "2026-11-01",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Features your plan does not include now say so",
        "ar": "الميزات غير المضمّنة في خطتك تُوضّح ذلك الآن",
        "de-DE": "Funktionen, die Ihr Tarif nicht enthält, sagen das jetzt",
        "fr-FR": "Les fonctionnalités non incluses dans votre forfait l’indiquent désormais",
        "es-ES": "Las funciones que tu plan no incluye ahora lo indican"
      },
      "items": {
        "en-US": [
          "If your plan does not include Group rules, it now sits under Upgrade to use in the side menu and More, and tapping it shows the plans that include it.",
          "The Group rules and Asset types pages open with the same upgrade prompt when your plan does not include them. Rules and types you already have stay listed below them, and rules can still be stopped. Nothing was removed."
        ],
        "ar": [
          "إذا كانت خطتك لا تتضمن قواعد المجموعات، فهي الآن ضمن «ترقية للاستخدام» في القائمة الجانبية وفي «المزيد»، والنقر عليها يعرض الخطط التي تتضمنها.",
          "تُفتح صفحتا قواعد المجموعات وأنواع الأصول بنفس دعوة الترقية عندما لا تتضمنهما خطتك. تبقى القواعد والأنواع الموجودة لديك معروضة أسفلها، ويمكن إيقاف القواعد. لم يُحذف أي شيء."
        ],
        "de-DE": [
          "Enthält Ihr Tarif keine Gruppenregeln, stehen sie jetzt im Seitenmenü und unter „Mehr“ bei „Mit Upgrade nutzbar“; ein Tippen zeigt die Tarife, die sie enthalten.",
          "Die Seiten Gruppenregeln und Anlagentypen öffnen mit demselben Upgrade-Hinweis, wenn Ihr Tarif sie nicht enthält. Vorhandene Regeln und Typen bleiben darunter aufgelistet, und Regeln lassen sich weiterhin beenden. Nichts wurde entfernt."
        ],
        "fr-FR": [
          "Si votre forfait n’inclut pas les règles de groupe, elles figurent désormais sous « Changer de forfait pour l’utiliser » dans le menu latéral et dans Plus ; un appui affiche les forfaits qui les incluent.",
          "Les pages Règles de groupe et Types d’actifs s’ouvrent sur la même invitation à changer de forfait lorsque votre forfait ne les inclut pas. Les règles et types existants restent listés en dessous, et les règles peuvent toujours être arrêtées. Rien n’a été supprimé."
        ],
        "es-ES": [
          "Si tu plan no incluye las reglas de grupo, ahora aparecen en «Mejora el plan para usarla» en el menú lateral y en Más, y al tocarlas se muestran los planes que las incluyen.",
          "Las páginas Reglas de grupo y Tipos de activo se abren con el mismo aviso de mejora cuando tu plan no las incluye. Las reglas y tipos que ya tienes siguen listados debajo, y las reglas se pueden seguir deteniendo. No se ha quitado nada."
        ]
      }
    },
    {
      "id": "2026-11-01-web-shared-asset-navigation",
      "date": "2026-11-01",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Simpler navigation on web: the side menu everywhere and Back goes up one level",
        "ar": "تنقل أبسط على الويب: القائمة الجانبية في كل مكان وزر الرجوع يصعد مستوى واحدًا",
        "de-DE": "Einfachere Navigation im Web: Seitenmenü überall, Zurück geht eine Ebene nach oben",
        "fr-FR": "Navigation plus simple sur le web : le menu latéral partout et Retour remonte d’un niveau",
        "es-ES": "Navegación más sencilla en la web: el menú lateral en todas partes y Atrás sube un nivel"
      },
      "items": {
        "en-US": [
          "On web, the Back arrow on a detail page now always goes up one level, to the page shown above it in the trail at the top: a job or request goes to its asset, an asset to its site, a site to Sites. Your browser's own back button still retraces your steps.",
          "Requests now show the trail too (Site › Asset › Request), and the trail always names the site, even if you have not opened Sites first.",
          "An asset someone shared with you, its requests, a shared report and a quote request now keep the side menu on web and tablet. Nothing was removed."
        ],
        "ar": [
          "على الويب، يصعد سهم الرجوع في صفحة التفاصيل الآن دائمًا مستوى واحدًا إلى الصفحة الظاهرة فوقها في المسار أعلى الصفحة: المهمة أو الطلب إلى الأصل، والأصل إلى موقعه، والموقع إلى المواقع. زر الرجوع في المتصفح ما زال يعيدك خطوة بخطوة.",
          "تعرض الطلبات الآن المسار أيضًا (الموقع › الأصل › الطلب)، ويذكر المسار الموقع دائمًا حتى لو لم تفتح المواقع أولًا.",
          "الأصل الذي شاركه أحدهم معك وطلباته والتقرير المشترك وطلب عرض السعر تحتفظ الآن بالقائمة الجانبية على الويب والجهاز اللوحي. لم يُحذف أي شيء."
        ],
        "de-DE": [
          "Im Web führt der Zurück-Pfeil auf einer Detailseite jetzt immer eine Ebene nach oben, zur Seite, die der Pfad oben darüber zeigt: ein Auftrag oder eine Anfrage zur Anlage, eine Anlage zu ihrem Standort, ein Standort zu Standorte. Die Zurück-Taste des Browsers geht weiterhin Ihren Weg zurück.",
          "Anfragen zeigen jetzt ebenfalls den Pfad (Standort › Anlage › Anfrage), und der Pfad nennt immer den Standort, auch wenn Sie Standorte nicht zuerst geöffnet haben.",
          "Eine mit Ihnen geteilte Anlage, ihre Anfragen, ein geteilter Bericht und eine Angebotsanfrage behalten jetzt im Web und auf dem Tablet das Seitenmenü. Nichts wurde entfernt."
        ],
        "fr-FR": [
          "Sur le web, la flèche Retour d’une page de détail remonte désormais toujours d’un niveau, vers la page affichée au-dessus dans le fil d’Ariane : un travail ou une demande vers son actif, un actif vers son site, un site vers Sites. Le bouton Retour du navigateur refait toujours votre parcours.",
          "Les demandes affichent aussi le fil d’Ariane (Site › Actif › Demande), et le fil nomme toujours le site, même si vous n’avez pas ouvert Sites avant.",
          "Un actif partagé avec vous, ses demandes, un rapport partagé et une demande de devis gardent désormais le menu latéral sur le web et la tablette. Rien n’a été supprimé."
        ],
        "es-ES": [
          "En la web, la flecha Atrás de una página de detalle ahora siempre sube un nivel, a la página que muestra la ruta de arriba: un trabajo o una solicitud a su activo, un activo a su sitio, un sitio a Sitios. El botón Atrás del navegador sigue deshaciendo tu recorrido.",
          "Las solicitudes también muestran la ruta (Sitio › Activo › Solicitud), y la ruta siempre nombra el sitio, aunque no hayas abierto Sitios antes.",
          "Un activo que alguien compartió contigo, sus solicitudes, un informe compartido y una solicitud de presupuesto mantienen ahora el menú lateral en la web y la tableta. No se ha quitado nada."
        ]
      }
    },
    {
      "id": "2026-11-01-case-reply-above-keyboard",
      "date": "2026-11-01",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "You can see what you type in a case reply on a phone",
        "ar": "يمكنك رؤية ما تكتبه في رد الحالة على الهاتف",
        "de-DE": "Antworten im Fall-Verlauf bleiben auf dem Telefon sichtbar",
        "fr-FR": "Vous voyez ce que vous tapez dans une réponse de dossier sur téléphone",
        "es-ES": "Ves lo que escribes en una respuesta del caso en el teléfono"
      },
      "items": {
        "en-US": [
          "The reply box under a case timeline now moves up above the keyboard on iPhone and Android, so the text you type stays in view. Nothing moved."
        ],
        "ar": [
          "أصبح مربع الرد أسفل سجل الحالة يرتفع فوق لوحة المفاتيح على iPhone وAndroid، فيبقى النص الذي تكتبه ظاهرًا. لم يُنقل أي شيء."
        ],
        "de-DE": [
          "Das Antwortfeld unter dem Fall-Verlauf rückt auf iPhone und Android jetzt über die Tastatur, sodass Ihr Text sichtbar bleibt. Nichts wurde verschoben."
        ],
        "fr-FR": [
          "La zone de réponse sous la chronologie d’un dossier remonte désormais au-dessus du clavier sur iPhone et Android : le texte saisi reste visible. Rien n’a été déplacé."
        ],
        "es-ES": [
          "El cuadro de respuesta bajo la cronología del caso ahora sube por encima del teclado en iPhone y Android, así el texto que escribes sigue a la vista. No se ha movido nada."
        ]
      }
    },
    {
      "id": "2026-11-01-get-started-share-step",
      "date": "2026-11-01",
      "version": "2.0.1",
      "showInApp": false,
      "title": {
        "en-US": "Get started ticks “Share an asset” when you share one",
        "ar": "قائمة «ابدأ» تؤشر على «مشاركة أصل» عندما تشارك أصلًا",
        "de-DE": "„Erste Schritte“ hakt „Ein Asset teilen“ ab, sobald Sie eines teilen",
        "fr-FR": "« Premiers pas » coche « Partager un actif » dès que vous en partagez un",
        "es-ES": "«Primeros pasos» marca «Compartir un activo» en cuanto compartes uno"
      },
      "items": {
        "en-US": [
          "Sharing one of your assets with a person now ticks the Get started step on Home. Before, only a request on an asset ticked it. Nothing moved."
        ],
        "ar": [
          "مشاركة أحد أصولك مع شخص تؤشر الآن على خطوة «ابدأ» في الصفحة الرئيسية. كان الطلب على أصل وحده يؤشر عليها من قبل. لم يُنقل أي شيء."
        ],
        "de-DE": [
          "Wenn Sie eines Ihrer Assets mit einer Person teilen, wird der Schritt unter „Erste Schritte“ auf der Startseite jetzt abgehakt. Bisher tat das nur eine Anfrage zu einem Asset. Nichts wurde verschoben."
        ],
        "fr-FR": [
          "Partager l’un de vos actifs avec une personne coche désormais l’étape de « Premiers pas » sur l’accueil. Avant, seule une demande sur un actif la cochait. Rien n’a été déplacé."
        ],
        "es-ES": [
          "Compartir uno de tus activos con una persona marca ahora el paso de «Primeros pasos» en Inicio. Antes solo lo marcaba una solicitud sobre un activo. No se ha movido nada."
        ]
      }
    },
    {
      "id": "2026-11-01-web-side-strips",
      "date": "2026-11-01",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Notifications and assistant strips look right again on web and tablet",
        "ar": "شريطا الإشعارات والمساعد يظهران بشكل صحيح مجددًا على الويب والجهاز اللوحي",
        "de-DE": "Benachrichtigungs- und Assistentenleiste im Web und auf dem Tablet wieder richtig",
        "fr-FR": "Les bandes Notifications et Assistant s’affichent de nouveau correctement sur le web et la tablette",
        "es-ES": "Las franjas de notificaciones y del asistente vuelven a verse bien en la web y la tableta"
      },
      "items": {
        "en-US": [
          "The thin notifications strip beside the side menu and the assistant strip on the right have their background and edge line back, and the unread count sits under the notifications button so it is never cut off. Nothing moved."
        ],
        "ar": [
          "عادت الخلفية والحافة إلى شريط الإشعارات الرفيع بجانب القائمة الجانبية وشريط المساعد على اليمين، ويظهر عدد غير المقروء تحت زر الإشعارات فلا يُقتطع أبدًا. لم يُنقل أي شيء."
        ],
        "de-DE": [
          "Die schmale Benachrichtigungsleiste neben dem Seitenmenü und die Assistentenleiste rechts haben wieder Hintergrund und Randlinie, und die Zahl der ungelesenen Meldungen steht unter der Schaltfläche, damit sie nie abgeschnitten wird. Nichts wurde verschoben."
        ],
        "fr-FR": [
          "La fine bande Notifications à côté du menu latéral et la bande Assistant à droite retrouvent leur fond et leur bordure, et le nombre de non-lus s’affiche sous le bouton Notifications pour ne jamais être coupé. Rien n’a été déplacé."
        ],
        "es-ES": [
          "La franja estrecha de notificaciones junto al menú lateral y la franja del asistente a la derecha recuperan su fondo y su borde, y el número de no leídas aparece debajo del botón de notificaciones para que nunca se corte. No se ha movido nada."
        ]
      }
    },
    {
      "id": "2026-11-01-report-scores-match-the-app",
      "date": "2026-11-01",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "AI reports show the same scores as the asset and site pages",
        "ar": "تقارير الذكاء الاصطناعي تعرض الدرجات نفسها الظاهرة في صفحات الأصول والمواقع",
        "de-DE": "KI-Berichte zeigen dieselben Werte wie die Anlagen- und Standortseiten",
        "fr-FR": "Les rapports IA affichent les mêmes scores que les pages actif et site",
        "es-ES": "Los informes de IA muestran las mismas puntuaciones que las páginas de activo y sitio"
      },
      "items": {
        "en-US": [
          "The risk, health and compliance scores in an asset or site AI report now come from the app's own scoring, the same numbers you see on the asset and site pages. The AI still writes the explanation and recommendations.",
          "Risk in a report is the asset's risk score on the same 1 to 25 scale as its risk card. A site report averages the scores of the site's assets that have something recorded.",
          "Reports you already generated keep their original figures; generate a new one to see the matching scores."
        ],
        "ar": [
          "أصبحت درجات المخاطر والحالة والامتثال في تقرير الذكاء الاصطناعي للأصل أو الموقع تأتي من حسابات التطبيق نفسه، وهي الأرقام نفسها التي تراها في صفحات الأصول والمواقع. ولا يزال الذكاء الاصطناعي يكتب الشرح والتوصيات.",
          "المخاطر في التقرير هي درجة مخاطر الأصل على مقياس 1 إلى 25 نفسه المستخدم في بطاقة المخاطر. ويحسب تقرير الموقع متوسط درجات أصول الموقع التي سُجّل لها شيء.",
          "تحتفظ التقارير التي أنشأتها سابقًا بأرقامها الأصلية؛ أنشئ تقريرًا جديدًا لترى الدرجات المطابقة."
        ],
        "de-DE": [
          "Die Werte für Risiko, Zustand und Konformität in einem KI-Bericht zu einer Anlage oder einem Standort stammen jetzt aus der eigenen Bewertung der App – dieselben Zahlen wie auf den Anlagen- und Standortseiten. Erklärung und Empfehlungen schreibt weiterhin die KI.",
          "Das Risiko im Bericht ist der Risikowert der Anlage auf derselben Skala von 1 bis 25 wie auf ihrer Risikokarte. Ein Standortbericht bildet den Durchschnitt der Anlagen des Standorts, zu denen etwas erfasst ist.",
          "Bereits erstellte Berichte behalten ihre ursprünglichen Werte; erstellen Sie einen neuen Bericht, um die passenden Werte zu sehen."
        ],
        "fr-FR": [
          "Les scores de risque, d’état et de conformité d’un rapport IA d’actif ou de site viennent désormais du calcul de l’application, les mêmes chiffres que sur les pages actif et site. L’IA rédige toujours l’explication et les recommandations.",
          "Le risque dans un rapport est le score de risque de l’actif, sur la même échelle de 1 à 25 que sa fiche de risque. Un rapport de site fait la moyenne des actifs du site pour lesquels quelque chose est enregistré.",
          "Les rapports déjà générés gardent leurs chiffres d’origine ; générez-en un nouveau pour voir les scores concordants."
        ],
        "es-ES": [
          "Las puntuaciones de riesgo, estado y cumplimiento de un informe de IA de activo o sitio ahora salen del cálculo de la propia app, las mismas cifras que ves en las páginas de activo y sitio. La IA sigue redactando la explicación y las recomendaciones.",
          "El riesgo del informe es la puntuación de riesgo del activo en la misma escala de 1 a 25 que su tarjeta de riesgo. Un informe de sitio promedia los activos del sitio que tienen algo registrado.",
          "Los informes que ya generaste conservan sus cifras originales; genera uno nuevo para ver las puntuaciones coincidentes."
        ]
      }
    },
    {
      "id": "2026-10-31-grouped-phone-more",
      "date": "2026-10-31",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "The phone's More menu uses the same groups as the side menu",
        "ar": "قائمة «المزيد» على الهاتف بمجموعات القائمة الجانبية نفسها",
        "de-DE": "„Mehr“ auf dem Telefon mit denselben Gruppen wie das Seitenmenü",
        "fr-FR": "« Plus » sur téléphone reprend les groupes du menu latéral",
        "es-ES": "«Más» en el teléfono usa los mismos grupos que el menú lateral"
      },
      "items": {
        "en-US": [
          "More on a phone is grouped like the side menu: Work (Calendar), Manage (Sites, Contacts, Checklists, Group rules) and Insight (Insights, Compliance, Knowledge, Activity), with the Assistant, Help and Account at the bottom. Nothing was removed; Checklists and Group rules moved into Manage, Knowledge into Insight, the Assistant next to Help, and Account to the last row.",
          "Anything your plan does not include is now listed together under Upgrade to use, as on the side menu."
        ],
        "ar": [
          "أصبحت «المزيد» على الهاتف مجمّعة مثل القائمة الجانبية: «العمل» (التقويم)، و«إدارة» (المواقع، جهات الاتصال، قوائم التحقق، قواعد المجموعات)، و«رؤى» (الرؤى، الامتثال، قاعدة المعرفة، النشاط)، مع «المساعد» و«المساعدة» و«الحساب» في الأسفل. لم يُحذف شيء؛ انتقلت قوائم التحقق وقواعد المجموعات إلى «إدارة»، وقاعدة المعرفة إلى «رؤى»، والمساعد بجوار «المساعدة»، والحساب إلى آخر صف.",
          "ما لا تتضمنه خطتك يظهر الآن معًا تحت «ترقية للاستخدام»، كما في القائمة الجانبية."
        ],
        "de-DE": [
          "„Mehr“ auf dem Telefon ist wie das Seitenmenü gruppiert: „Arbeit“ (Kalender), „Verwalten“ (Standorte, Kontakte, Checklisten, Gruppenregeln) und „Einblick“ (Analysen, Konformität, Wissen, Aktivität), mit „Assistent“, „Hilfe“ und „Konto“ ganz unten. Nichts wurde entfernt; Checklisten und Gruppenregeln sind nach „Verwalten“ gerückt, Wissen nach „Einblick“, der Assistent neben „Hilfe“ und „Konto“ in die letzte Zeile.",
          "Was Ihr Tarif nicht enthält, steht jetzt gesammelt unter „Mit Upgrade nutzbar“, wie im Seitenmenü."
        ],
        "fr-FR": [
          "« Plus » sur téléphone est regroupé comme le menu latéral : « Travail » (Calendrier), « Gérer » (Sites, Contacts, Listes de contrôle, Règles de groupe) et « Analyse » (Analytique, Conformité, Connaissances, Activité), avec « Assistant IA », « Aide » et « Compte » en bas. Rien n’a été retiré : Listes de contrôle et Règles de groupe ont rejoint « Gérer », Connaissances « Analyse », l’assistant est à côté d’« Aide » et « Compte » est sur la dernière ligne.",
          "Ce que votre forfait n’inclut pas est désormais regroupé sous « Changer de forfait pour l’utiliser », comme dans le menu latéral."
        ],
        "es-ES": [
          "«Más» en el teléfono está agrupado como el menú lateral: «Trabajo» (Calendario), «Gestionar» (Sitios, Contactos, Listas de verificación, Reglas de grupo) y «Análisis» (Analítica, Cumplimiento, Conocimiento, Actividad), con «Asistente», «Ayuda» y «Cuenta» al final. No se ha quitado nada: Listas de verificación y Reglas de grupo pasan a «Gestionar», Conocimiento a «Análisis», el asistente junto a «Ayuda» y «Cuenta» a la última fila.",
          "Lo que su plan no incluye aparece ahora junto en «Mejora el plan para usarla», como en el menú lateral."
        ]
      }
    },
    {
      "id": "2026-10-31-sharper-web-and-tablet",
      "date": "2026-10-31",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "A sharper look on tablet and web",
        "ar": "مظهر أوضح على الجهاز اللوحي والويب",
        "de-DE": "Klareres Aussehen auf Tablet und Web",
        "fr-FR": "Un affichage plus net sur tablette et sur le web",
        "es-ES": "Un aspecto más nítido en tableta y web"
      },
      "items": {
        "en-US": [
          "Cards, buttons and search fields are flatter and more even, page titles are a little smaller, and the side strips no longer draw a frame.",
          "Checklists, Group rules and Knowledge open from the side menu without a back arrow; it still appears when another page led you there. On an asset, the name now shows once, in the page title.",
          "On asset cards the directions button sits at the top right, and approve and send back buttons no longer stretch across the page. Nothing changes on phones."
        ],
        "ar": [
          "أصبحت البطاقات والأزرار وحقول البحث أبسط وأكثر تناسقًا، وعناوين الصفحات أصغر قليلًا، ولم تعد الأشرطة الجانبية تظهر بإطار.",
          "تُفتح قوائم التحقق وقواعد المجموعات والمعرفة من القائمة الجانبية دون سهم رجوع، ويظهر السهم عند الوصول إليها من صفحة أخرى. في صفحة الأصل يظهر الاسم مرة واحدة في عنوان الصفحة.",
          "في بطاقات الأصول أصبح زر الاتجاهات في الأعلى يمينًا، ولم تعد أزرار الاعتماد والإرجاع تمتد بعرض الصفحة. لا شيء يتغير على الهواتف."
        ],
        "de-DE": [
          "Karten, Schaltflächen und Suchfelder wirken flacher und gleichmäßiger, Seitentitel sind etwas kleiner, und die Seitenleisten haben keinen Rahmen mehr.",
          "Checklisten, Gruppenregeln und Wissen öffnen sich aus dem Seitenmenü ohne Zurück-Pfeil; er erscheint weiterhin, wenn Sie von einer anderen Seite kommen. Bei einem Asset steht der Name jetzt nur einmal im Seitentitel.",
          "Auf Asset-Karten sitzt die Schaltfläche für die Route oben rechts, und Freigeben und Zurücksenden ziehen sich nicht mehr über die ganze Seite. Auf Smartphones ändert sich nichts."
        ],
        "fr-FR": [
          "Les cartes, boutons et champs de recherche sont plus sobres et plus réguliers, les titres de page un peu plus petits, et les bandeaux latéraux n’ont plus de cadre.",
          "Listes de contrôle, Règles de groupe et Connaissances s’ouvrent depuis le menu latéral sans flèche de retour ; elle apparaît toujours si vous venez d’une autre page. Sur un actif, le nom n’apparaît plus qu’une fois, dans le titre de la page.",
          "Sur les cartes d’actif, le bouton d’itinéraire est en haut à droite, et les boutons Approuver et Renvoyer ne s’étirent plus sur toute la page. Rien ne change sur téléphone."
        ],
        "es-ES": [
          "Las tarjetas, los botones y los campos de búsqueda son más planos y uniformes, los títulos de página algo más pequeños y las franjas laterales ya no tienen marco.",
          "Listas de control, Reglas de grupo y Conocimiento se abren desde el menú lateral sin flecha de volver; sigue apareciendo si llegas desde otra página. En un activo, el nombre aparece una sola vez, en el título de la página.",
          "En las tarjetas de activo, el botón de indicaciones está arriba a la derecha, y los botones Aprobar y Devolver ya no ocupan todo el ancho de la página. En los teléfonos no cambia nada."
        ]
      }
    },
    {
      "id": "2026-10-31-grouped-side-menu",
      "date": "2026-10-31",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "A tidier side menu on tablets and computers",
        "ar": "قائمة جانبية أكثر ترتيبًا على الأجهزة اللوحية والحواسيب",
        "de-DE": "Ein aufgeräumteres Seitenmenü auf Tablet und Computer",
        "fr-FR": "Un menu latéral mieux rangé sur tablette et ordinateur",
        "es-ES": "Un menú lateral más ordenado en tabletas y ordenadores"
      },
      "items": {
        "en-US": [
          "The side menu is grouped: Home, then Work (Work, Calendar), Manage (Sites, Assets, Contacts, Checklists, Group rules) and Insight (Insights, Compliance, Knowledge). Help and Account sit at the bottom. Nothing was removed; Calendar, Checklists, Group rules, Compliance and Knowledge moved up into their groups, and Account moved to the bottom.",
          "On an iPad or a smaller window, tap the arrow at the top of the menu to see it with names. On a short window the menu now scrolls, so Help is always reachable."
        ],
        "ar": [
          "أصبحت القائمة الجانبية مجمّعة: «الرئيسية»، ثم «العمل» (العمل، التقويم)، و«إدارة» (المواقع، الأصول، جهات الاتصال، قوائم التحقق، قواعد المجموعات)، و«رؤى» (الرؤى، الامتثال، قاعدة المعرفة). ويبقى «المساعدة» و«الحساب» في الأسفل. لم يُحذف شيء؛ انتقلت التقويم وقوائم التحقق وقواعد المجموعات والامتثال وقاعدة المعرفة إلى مجموعاتها، وانتقل الحساب إلى الأسفل.",
          "على iPad أو نافذة أصغر، اضغط السهم أعلى القائمة لتراها بالأسماء. وفي النافذة القصيرة أصبحت القائمة تُمرَّر، فتصل إلى «المساعدة» دائمًا."
        ],
        "de-DE": [
          "Das Seitenmenü ist gruppiert: „Start“, dann „Arbeit“ (Arbeit, Kalender), „Verwalten“ (Standorte, Anlagen, Kontakte, Checklisten, Gruppenregeln) und „Einblick“ (Analysen, Konformität, Wissen). „Hilfe“ und „Konto“ stehen unten. Nichts wurde entfernt; Kalender, Checklisten, Gruppenregeln, Konformität und Wissen sind in ihre Gruppen gerückt, „Konto“ nach unten.",
          "Tippen Sie auf einem iPad oder in einem kleineren Fenster oben im Menü auf den Pfeil, um es mit Namen zu sehen. In einem niedrigen Fenster lässt sich das Menü jetzt scrollen, sodass „Hilfe“ immer erreichbar ist."
        ],
        "fr-FR": [
          "Le menu latéral est regroupé : « Accueil », puis « Travail » (Travail, Calendrier), « Gérer » (Sites, Actifs, Contacts, Listes de contrôle, Règles de groupe) et « Analyse » (Analytique, Conformité, Connaissances). « Aide » et « Compte » sont en bas. Rien n’a été retiré : Calendrier, Listes de contrôle, Règles de groupe, Conformité et Connaissances ont rejoint leur groupe, et « Compte » est passé en bas.",
          "Sur iPad ou dans une fenêtre plus petite, touchez la flèche en haut du menu pour l’afficher avec les noms. Dans une fenêtre peu haute, le menu défile désormais : « Aide » est toujours accessible."
        ],
        "es-ES": [
          "El menú lateral está agrupado: «Inicio», luego «Trabajo» (Trabajo, Calendario), «Gestionar» (Sitios, Activos, Contactos, Listas de verificación, Reglas de grupo) y «Análisis» (Analítica, Cumplimiento, Conocimiento). «Ayuda» y «Cuenta» quedan abajo. No se ha quitado nada: Calendario, Listas de verificación, Reglas de grupo, Cumplimiento y Conocimiento han subido a su grupo, y «Cuenta» ha bajado al final.",
          "En un iPad o una ventana más pequeña, toque la flecha de arriba del menú para verlo con nombres. En una ventana baja, el menú ahora se desplaza, así que «Ayuda» siempre está a mano."
        ]
      }
    },
    {
      "id": "2026-10-31-api-explorer-shows-plan-switches",
      "date": "2026-10-31",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "The API explorer shows what your plan includes",
        "ar": "مستكشف واجهة البرمجة يبيّن ما تشمله خطتك",
        "de-DE": "Der API-Explorer zeigt, was Ihr Tarif enthält",
        "fr-FR": "L’explorateur d’API montre ce que comprend votre offre",
        "es-ES": "El explorador de la API muestra lo que incluye tu plan"
      },
      "items": {
        "en-US": [
          "Each section of the API explorer now names the plan switch it needs, and says \"Not in your plan\" when it is switched off, instead of the calls just failing.",
          "Every workspace is now always on a plan; new workspaces start on Free."
        ],
        "ar": [
          "يذكر كل قسم في مستكشف واجهة البرمجة الآن مفتاح الخطة الذي يحتاجه، ويقول \"غير مشمول في خطتك\" عندما يكون متوقفًا، بدلًا من أن تفشل الطلبات فقط.",
          "كل مساحة عمل الآن على خطة دائمًا؛ وتبدأ مساحات العمل الجديدة على الخطة المجانية."
        ],
        "de-DE": [
          "Jeder Bereich im API-Explorer nennt jetzt den Tarif-Schalter, den er braucht, und zeigt „Nicht in Ihrem Tarif“, wenn er ausgeschaltet ist, statt dass die Aufrufe einfach fehlschlagen.",
          "Jeder Arbeitsbereich hat jetzt immer einen Tarif; neue Arbeitsbereiche starten mit Free."
        ],
        "fr-FR": [
          "Chaque section de l’explorateur d’API indique maintenant l’option de l’offre dont elle a besoin, et affiche « Non inclus dans votre offre » quand elle est désactivée, au lieu de laisser les appels échouer.",
          "Chaque espace de travail a désormais toujours une offre ; les nouveaux espaces commencent sur Free."
        ],
        "es-ES": [
          "Cada sección del explorador de la API indica ahora el interruptor del plan que necesita y muestra «No incluido en tu plan» cuando está desactivado, en lugar de que las llamadas simplemente fallen.",
          "Cada espacio de trabajo tiene ahora siempre un plan; los nuevos empiezan en Free."
        ]
      }
    },
    {
      "id": "2026-10-31-every-feature-has-its-switch",
      "date": "2026-10-31",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Your plan decides every feature",
        "ar": "خطتك تحدد كل ميزة",
        "de-DE": "Ihr Tarif bestimmt jede Funktion",
        "fr-FR": "Votre offre décide de chaque fonctionnalité",
        "es-ES": "Tu plan decide cada función"
      },
      "items": {
        "en-US": [
          "Every feature now follows your plan, including group rules, rounds, asset types, bulk setup, contact import, AI checklists and the assistant's extra powers. Nothing changes for you today: every plan still includes them.",
          "If a plan leaves a feature out, it is hidden or says \"Not included in your plan\", the assistant says so too, and no AI credit is spent. Records you already made stay readable and editable."
        ],
        "ar": [
          "تتبع كل ميزة الآن خطتك، بما فيها قواعد المجموعات والجولات وأنواع الأصول والإعداد الجماعي واستيراد جهات الاتصال وقوائم التحقق بالذكاء الاصطناعي وقدرات المساعد الإضافية. لا يتغير شيء لك اليوم: كل الخطط ما زالت تتضمنها.",
          "إذا لم تتضمن خطة ميزة ما، فإنها تُخفى أو تظهر عبارة \"غير مضمّنة في خطتك\"، ويقول المساعد ذلك أيضًا، ولا يُستهلك أي رصيد ذكاء اصطناعي. تبقى السجلات التي أنشأتها قابلة للقراءة والتعديل."
        ],
        "de-DE": [
          "Jede Funktion richtet sich jetzt nach Ihrem Tarif, auch Gruppenregeln, Rundgänge, Anlagentypen, Massenerstellung, Kontaktimport, KI-Checklisten und die erweiterten Fähigkeiten des Assistenten. Heute ändert sich für Sie nichts: Jeder Tarif enthält sie weiterhin.",
          "Fehlt eine Funktion in einem Tarif, wird sie ausgeblendet oder zeigt „Nicht in Ihrem Tarif enthalten“, der Assistent sagt es ebenfalls, und es wird kein KI-Guthaben verbraucht. Bereits erstellte Datensätze bleiben lesbar und bearbeitbar."
        ],
        "fr-FR": [
          "Chaque fonctionnalité suit désormais votre offre, y compris les règles de groupe, les tournées, les types d’actifs, la création en masse, l’import de contacts, les checklists par IA et les capacités étendues de l’assistant. Rien ne change pour vous aujourd’hui : toutes les offres les incluent toujours.",
          "Si une offre exclut une fonctionnalité, elle est masquée ou affiche « Non inclus dans votre offre », l’assistant le dit aussi, et aucun crédit IA n’est dépensé. Les données déjà créées restent consultables et modifiables."
        ],
        "es-ES": [
          "Cada función sigue ahora tu plan, incluidas las reglas de grupo, las rondas, los tipos de activo, la creación masiva, la importación de contactos, las listas con IA y las capacidades ampliadas del asistente. Hoy no cambia nada para ti: todos los planes las siguen incluyendo.",
          "Si un plan deja fuera una función, se oculta o muestra «No incluido en tu plan», el asistente también lo dice y no se gasta ningún crédito de IA. Los registros que ya creaste siguen siendo legibles y editables."
        ]
      }
    },
    {
      "id": "2026-10-31-api-explorer-sites",
      "date": "2026-10-31",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Sites and more in the API",
        "ar": "المواقع والمزيد في واجهة البرمجة",
        "de-DE": "Standorte und mehr in der API",
        "fr-FR": "Les sites et plus encore dans l’API",
        "es-ES": "Sitios y más en la API"
      },
      "items": {
        "en-US": [
          "Integrations can now read your sites, checklists, scheduled inspections, maintenance plans and programmes, and teams through the API, GraphQL and the Power BI feed. They can read these but not change them.",
          "The API explorer lists everything the API offers, with a line at the top saying what it covers."
        ],
        "ar": [
          "يمكن للتكاملات الآن قراءة مواقعك وقوائم التحقق وعمليات التفتيش المجدولة وخطط الصيانة وبرامجها والفرق عبر واجهة البرمجة وGraphQL وموجز Power BI. يمكنها قراءتها دون تغييرها.",
          "يعرض مستكشف واجهة البرمجة كل ما توفره الواجهة، مع سطر في الأعلى يوضح ما تشمله."
        ],
        "de-DE": [
          "Integrationen können jetzt Ihre Standorte, Checklisten, geplanten Inspektionen, Wartungspläne und -programme sowie Teams über die API, GraphQL und den Power-BI-Feed lesen. Sie können sie lesen, aber nicht ändern.",
          "Der API-Explorer zeigt alles, was die API bietet, mit einer Zeile oben, die sagt, was sie umfasst."
        ],
        "fr-FR": [
          "Les intégrations peuvent désormais lire vos sites, listes de contrôle, inspections planifiées, plans et programmes de maintenance et équipes via l’API, GraphQL et le flux Power BI. Elles peuvent les lire mais pas les modifier.",
          "L’explorateur d’API liste tout ce que l’API propose, avec une ligne en haut qui indique ce qu’elle couvre."
        ],
        "es-ES": [
          "Las integraciones ya pueden leer sus sitios, listas de verificación, inspecciones programadas, planes y programas de mantenimiento y equipos a través de la API, GraphQL y el feed de Power BI. Pueden leerlos, pero no cambiarlos.",
          "El explorador de la API muestra todo lo que ofrece la API, con una línea arriba que indica lo que incluye."
        ]
      }
    },
    {
      "id": "2026-10-31-site-details-tab",
      "date": "2026-10-31",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Site details have their own tab",
        "ar": "لتفاصيل الموقع علامة تبويب خاصة بها",
        "de-DE": "Standortdetails haben einen eigenen Tab",
        "fr-FR": "Les détails du site ont leur propre onglet",
        "es-ES": "Los detalles del sitio tienen su propia pestaña"
      },
      "items": {
        "en-US": [
          "A site now has a Details tab, right after Overview, the same way an asset does. It holds the site's code, type, status, address, parent site, team, contacts and dates, with Edit and View on map. Overview starts with the description and the number tiles."
        ],
        "ar": [
          "أصبح للموقع الآن علامة تبويب «التفاصيل» بعد «نظرة عامة» مباشرة، كما في الأصل. وتضم رمز الموقع ونوعه وحالته وعنوانه والموقع الأصل والفريق وجهات الاتصال والتواريخ، مع «تعديل» و«عرض على الخريطة». وتبدأ «نظرة عامة» بالوصف ومربعات الأرقام."
        ],
        "de-DE": [
          "Ein Standort hat jetzt den Tab „Details“ direkt nach „Übersicht“, wie eine Anlage. Er enthält Code, Art, Status, Adresse, übergeordneten Standort, Team, Kontakte und Daten, mit „Bearbeiten“ und „Auf Karte anzeigen“. „Übersicht“ beginnt mit der Beschreibung und den Kennzahlen."
        ],
        "fr-FR": [
          "Un site a maintenant un onglet « Détails », juste après « Aperçu », comme un actif. Il réunit le code, le type, le statut, l’adresse, le site parent, l’équipe, les contacts et les dates, avec « Modifier » et « Voir sur la carte ». « Aperçu » commence par la description et les indicateurs."
        ],
        "es-ES": [
          "Un sitio tiene ahora una pestaña «Detalles», justo después de «Resumen», como un activo. Reúne el código, el tipo, el estado, la dirección, el sitio principal, el equipo, los contactos y las fechas, con «Editar» y «Ver en el mapa». «Resumen» empieza con la descripción y los indicadores."
        ]
      }
    },
    {
      "id": "2026-10-31-stability-fixes",
      "date": "2026-10-31",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Reliability fixes",
        "ar": "إصلاحات لتحسين الموثوقية",
        "de-DE": "Fehlerbehebungen für mehr Zuverlässigkeit",
        "fr-FR": "Corrections de fiabilité",
        "es-ES": "Correcciones de fiabilidad"
      },
      "items": {
        "en-US": [
          "The assistant's answers are now shown formatted, with headings, bullet points and bold figures, instead of * and # characters.",
          "A change you confirm with the assistant now runs once and is charged once, even after a double tap. If it fails, the credit is given back.",
          "A suggestion card more than a day old asks you to ask again, so it is never run from out-of-date records.",
          "Questions asked offline wait until you are back in the workspace you asked them in, and are never asked twice.",
          "A group rule can no longer create the same inspection twice.",
          "When many people open the Work page at once, the rest of the app stays fast. At very busy moments the Work page may ask you to try again."
        ],
        "ar": [
          "تظهر إجابات المساعد الآن منسّقة، بعناوين ونقاط وأرقام بخط عريض، بدلًا من الرمزين * و#.",
          "التغيير الذي تؤكده مع المساعد يُنفَّذ الآن مرة واحدة ويُحتسب مرة واحدة، حتى بعد النقر مرتين. وإذا فشل، يُعاد الرصيد.",
          "بطاقة الاقتراح التي مضى عليها أكثر من يوم تطلب منك السؤال من جديد، فلا تُنفَّذ أبدًا من سجلات قديمة.",
          "الأسئلة المطروحة دون اتصال تنتظر حتى تعود إلى مساحة العمل التي طرحتها فيها، ولا تُطرح مرتين أبدًا.",
          "لم يعد بإمكان قاعدة المجموعة إنشاء الفحص نفسه مرتين.",
          "عندما يفتح كثيرون صفحة العمل في الوقت نفسه، يبقى باقي التطبيق سريعًا. وفي أوقات الذروة الشديدة قد تطلب منك صفحة العمل المحاولة مرة أخرى."
        ],
        "de-DE": [
          "Die Antworten des Assistenten werden jetzt formatiert angezeigt, mit Überschriften, Aufzählungspunkten und fett gedruckten Zahlen statt der Zeichen * und #.",
          "Eine Änderung, die Sie beim Assistenten bestätigen, wird jetzt einmal ausgeführt und einmal berechnet, auch nach doppeltem Tippen. Schlägt sie fehl, wird das Guthaben erstattet.",
          "Eine Vorschlagskarte, die älter als einen Tag ist, bittet Sie, erneut zu fragen, damit sie nie mit veralteten Daten ausgeführt wird.",
          "Offline gestellte Fragen warten, bis Sie wieder im Arbeitsbereich sind, in dem Sie sie gestellt haben, und werden nie zweimal gestellt.",
          "Eine Gruppenregel kann dieselbe Inspektion nicht mehr zweimal anlegen.",
          "Wenn viele Personen gleichzeitig die Seite „Arbeit“ öffnen, bleibt der Rest der App schnell. In sehr ausgelasteten Momenten bittet die Seite „Arbeit“ Sie eventuell, es erneut zu versuchen."
        ],
        "fr-FR": [
          "Les réponses de l'assistant s'affichent désormais mises en forme, avec des titres, des puces et des chiffres en gras, au lieu des caractères * et #.",
          "Une modification que vous confirmez avec l'assistant s'exécute désormais une seule fois et n'est facturée qu'une fois, même après un double appui. Si elle échoue, le crédit est rendu.",
          "Une carte de suggestion vieille de plus d'un jour vous invite à redemander, pour ne jamais s'exécuter sur des données périmées.",
          "Les questions posées hors ligne attendent que vous reveniez dans l'espace de travail où vous les avez posées, et ne sont jamais posées deux fois.",
          "Une règle de groupe ne peut plus créer deux fois la même inspection.",
          "Quand beaucoup de personnes ouvrent la page Travail en même temps, le reste de l'application reste rapide. Aux moments très chargés, la page Travail peut vous demander de réessayer."
        ],
        "es-ES": [
          "Las respuestas del asistente ahora se muestran con formato, con títulos, viñetas y cifras en negrita, en lugar de los caracteres * y #.",
          "Un cambio que confirmas con el asistente ahora se ejecuta una sola vez y se cobra una sola vez, incluso tras un doble toque. Si falla, se devuelve el crédito.",
          "Una tarjeta de sugerencia de hace más de un día te pide que vuelvas a preguntar, para que nunca se ejecute con datos desactualizados.",
          "Las preguntas hechas sin conexión esperan a que vuelvas al espacio de trabajo en el que las hiciste y nunca se hacen dos veces.",
          "Una regla de grupo ya no puede crear la misma inspección dos veces.",
          "Cuando muchas personas abren la página Trabajo a la vez, el resto de la app sigue siendo rápido. En momentos de mucha carga, la página Trabajo puede pedirte que lo intentes de nuevo."
        ]
      }
    },
    {
      "id": "2026-10-30-create-menu-groups",
      "date": "2026-10-30",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "The Create menu is grouped like an asset's menu",
        "ar": "قائمة الإنشاء مجمّعة مثل قائمة الأصل",
        "de-DE": "Das Menü „Erstellen“ ist wie das Menü einer Anlage gruppiert",
        "fr-FR": "Le menu Créer est regroupé comme celui d'un actif",
        "es-ES": "El menú Crear se agrupa como el menú de un activo"
      },
      "items": {
        "en-US": [
          "The + on Home now shows Guide me, then Work (Inspection, Job, Report issue, Maintenance), then Manage (Asset, Site, Contact, Checklist), with the same headings as an asset's + menu. Asset has moved down into Manage.",
          "The + on the Work tab uses the same Work heading, and the + in the web top bar now lists Checklist too."
        ],
        "ar": [
          "يعرض زر + في الرئيسية الآن «أرشدني»، ثم «العمل» (فحص، مهمة، الإبلاغ عن عطل، صيانة)، ثم «إدارة» (أصل، موقع، جهة اتصال، قائمة تحقق)، بالعناوين نفسها الموجودة في قائمة + للأصل. انتقل «أصل» إلى مجموعة «إدارة».",
          "يستخدم زر + في تبويب العمل عنوان «العمل» نفسه، ويعرض زر + في الشريط العلوي على الويب «قائمة تحقق» أيضًا."
        ],
        "de-DE": [
          "Das + auf der Startseite zeigt jetzt „Anleitung“, dann „Arbeit“ (Inspektion, Auftrag, Mangel melden, Wartung), dann „Verwalten“ (Anlage, Standort, Kontakt, Checkliste), mit denselben Überschriften wie das +-Menü einer Anlage. „Anlage“ ist nach unten in „Verwalten“ gerückt.",
          "Das + im Tab „Arbeit“ nutzt dieselbe Überschrift „Arbeit“, und das + in der oberen Leiste im Web listet jetzt auch die Checkliste."
        ],
        "fr-FR": [
          "Le + de l'accueil affiche maintenant Guidez-moi, puis Travail (Inspection, Intervention, Signaler une anomalie, Maintenance), puis Gérer (Actif, Site, Contact, Check-list), avec les mêmes titres que le menu + d'un actif. Actif descend dans Gérer.",
          "Le + de l'onglet Travail reprend le titre Travail, et le + de la barre du haut sur le web affiche aussi Check-list."
        ],
        "es-ES": [
          "El + de Inicio muestra ahora Guíame, luego Trabajo (Inspección, Orden de trabajo, Reportar incidencia, Mantenimiento) y luego Gestionar (Activo, Sitio, Contacto, Lista de control), con los mismos títulos que el menú + de un activo. Activo baja a Gestionar.",
          "El + de la pestaña Trabajo usa el mismo título Trabajo, y el + de la barra superior en la web ahora también muestra Lista de control."
        ]
      }
    },
    {
      "id": "2026-10-30-group-rules-clearer",
      "date": "2026-10-30",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Group rules are easier to follow",
        "ar": "قواعد المجموعات أوضح الآن",
        "de-DE": "Gruppenregeln sind leichter zu verstehen",
        "fr-FR": "Les règles de groupe sont plus claires",
        "es-ES": "Las reglas de grupo son más fáciles de entender"
      },
      "items": {
        "en-US": [
          "Group rules now explain themselves: three steps and an example on the screen, the rule read back in one sentence, a Guide me tour and its own guide article.",
          "Editing a rule now updates its inspections that have not started, and the form says how many will change first. Started and finished inspections never change.",
          "Pick the first date from a calendar, choose Any place, and assign a rule's inspections to one person. Each inspection a rule made links back to it.",
          "The assistant can explain your group rules, and set one up or stop one when you confirm."
        ],
        "ar": [
          "تشرح قواعد المجموعات نفسها الآن: ثلاث خطوات ومثال على الشاشة، وتُقرأ القاعدة في جملة واحدة، مع جولة أرشدني ومقال خاص في الدليل.",
          "تعديل القاعدة يحدّث الآن فحوصاتها التي لم تبدأ، ويذكر النموذج أولًا عدد ما سيتغير. الفحوصات التي بدأت أو انتهت لا تتغير أبدًا.",
          "اختر التاريخ الأول من التقويم، واختر أي مكان، وأسند فحوصات القاعدة إلى شخص واحد. وكل فحص أنشأته قاعدة يرتبط بها.",
          "يمكن للمساعد شرح قواعد المجموعات، وإعداد قاعدة أو إيقافها عند تأكيدك."
        ],
        "de-DE": [
          "Gruppenregeln erklären sich jetzt selbst: drei Schritte und ein Beispiel auf dem Bildschirm, die Regel in einem Satz, eine Führung unter „Zeig es mir“ und ein eigener Artikel in der Anleitung.",
          "Wenn Sie eine Regel bearbeiten, ändern sich jetzt ihre noch nicht begonnenen Prüfungen, und das Formular zeigt vorher, wie viele. Begonnene und erledigte Prüfungen ändern sich nie.",
          "Wählen Sie das erste Datum im Kalender, wählen Sie „Jeder Ort“ und weisen Sie die Prüfungen einer Regel einer Person zu. Jede Prüfung aus einer Regel verlinkt zurück auf sie.",
          "Der Assistent erklärt Ihre Gruppenregeln und richtet eine ein oder stoppt sie, wenn Sie bestätigen."
        ],
        "fr-FR": [
          "Les règles de groupe s'expliquent d'elles-mêmes : trois étapes et un exemple à l'écran, la règle résumée en une phrase, une visite guidée et un article dédié dans le guide.",
          "Modifier une règle met maintenant à jour ses inspections non commencées, et le formulaire indique d'abord combien changeront. Les inspections commencées ou terminées ne changent jamais.",
          "Choisissez la première date dans un calendrier, choisissez Tout lieu et attribuez les inspections d'une règle à une personne. Chaque inspection issue d'une règle renvoie vers elle.",
          "L'assistant peut expliquer vos règles de groupe, et en créer ou en arrêter une quand vous confirmez."
        ],
        "es-ES": [
          "Las reglas de grupo ahora se explican solas: tres pasos y un ejemplo en la pantalla, la regla resumida en una frase, una visita guiada y su propio artículo en la guía.",
          "Editar una regla ahora actualiza sus inspecciones no iniciadas, y el formulario dice antes cuántas cambiarán. Las inspecciones iniciadas o terminadas nunca cambian.",
          "Elige la primera fecha en un calendario, elige Cualquier lugar y asigna las inspecciones de una regla a una persona. Cada inspección creada por una regla enlaza con ella.",
          "El asistente puede explicar tus reglas de grupo, y crear o detener una cuando lo confirmes."
        ]
      }
    },
    {
      "id": "2026-10-30-work-tab-phone-layout",
      "date": "2026-10-30",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "A tidier Work tab on phones",
        "ar": "تبويب العمل أكثر ترتيبًا على الهواتف",
        "de-DE": "Aufgeräumterer Arbeitsbereich auf dem Handy",
        "fr-FR": "Un onglet Travail plus net sur téléphone",
        "es-ES": "Una pestaña Trabajo más ordenada en el móvil"
      },
      "items": {
        "en-US": [
          "On a phone, Day, Week and 2 weeks sit on their own row, with the dates and Today below, so nothing is cut off.",
          "The Work filters have a full row, with Refine and the view switch underneath.",
          "The week view shows more days at once and makes clear it scrolls sideways, and the 2-weeks calendar is more compact."
        ],
        "ar": [
          "على الهاتف، تظهر خيارات اليوم والأسبوع وأسبوعين في صف خاص بها، مع التواريخ وزر اليوم أسفلها، فلا يُقطع شيء.",
          "لمرشحات العمل صف كامل، ويظهر زر التصفية ومبدّل العرض تحتها.",
          "يعرض عرض الأسبوع أيامًا أكثر ويوضح أنه يُمرَّر جانبيًا، وأصبح تقويم الأسبوعين أكثر إحكامًا."
        ],
        "de-DE": [
          "Auf dem Handy stehen Tag, Woche und 2 Wochen in einer eigenen Zeile, Datum und Heute darunter, sodass nichts abgeschnitten wird.",
          "Die Filter unter Arbeit haben eine ganze Zeile, Verfeinern und die Ansichtsauswahl stehen darunter.",
          "Die Wochenansicht zeigt mehr Tage auf einmal und macht deutlich, dass sie seitlich scrollt; der 2-Wochen-Kalender ist kompakter."
        ],
        "fr-FR": [
          "Sur téléphone, Jour, Semaine et 2 semaines ont leur propre ligne, avec les dates et Aujourd'hui en dessous : plus rien n'est coupé.",
          "Les filtres de Travail ont une ligne entière, avec Affiner et le choix de vue en dessous.",
          "La vue semaine affiche plus de jours et montre qu'elle défile sur le côté, et le calendrier sur 2 semaines est plus compact."
        ],
        "es-ES": [
          "En el móvil, Día, Semana y 2 semanas tienen su propia fila, con las fechas y Hoy debajo, así que nada queda cortado.",
          "Los filtros de Trabajo tienen una fila completa, con Refinar y el cambio de vista debajo.",
          "La vista semanal muestra más días a la vez y deja claro que se desplaza hacia el lado, y el calendario de 2 semanas es más compacto."
        ]
      }
    },
    {
      "id": "2026-10-30-assistant-phone-layout",
      "date": "2026-10-30",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "More room for the assistant on phones",
        "ar": "مساحة أكبر للمساعد على الهواتف",
        "de-DE": "Mehr Platz für den Assistenten auf dem Handy",
        "fr-FR": "Plus de place pour l'assistant sur téléphone",
        "es-ES": "Más espacio para el asistente en el móvil"
      },
      "items": {
        "en-US": [
          "On phones the assistant now opens full height with a one-line header, so more of the conversation shows. Start a new conversation with the + at the top.",
          "Links under an answer are short buttons again, each shown once."
        ],
        "ar": [
          "على الهواتف يفتح المساعد الآن بالطول الكامل مع رأس من سطر واحد، فيظهر جزء أكبر من المحادثة. ابدأ محادثة جديدة بزر + في الأعلى.",
          "الروابط أسفل الإجابة أزرار قصيرة مرة أخرى، ويظهر كل منها مرة واحدة."
        ],
        "de-DE": [
          "Auf dem Handy öffnet sich der Assistent jetzt in voller Höhe mit einzeiliger Kopfzeile, damit mehr vom Gespräch sichtbar ist. Ein neues Gespräch starten Sie mit dem + oben.",
          "Links unter einer Antwort sind wieder kurze Schaltflächen, jede nur einmal."
        ],
        "fr-FR": [
          "Sur téléphone, l'assistant s'ouvre maintenant en pleine hauteur avec un en-tête d'une ligne, pour voir davantage de la conversation. Démarrez une nouvelle conversation avec le + en haut.",
          "Les liens sous une réponse redeviennent de courts boutons, chacun affiché une fois."
        ],
        "es-ES": [
          "En el móvil el asistente se abre ahora a altura completa con una cabecera de una línea, para ver más de la conversación. Empieza una conversación nueva con el + de arriba.",
          "Los enlaces bajo una respuesta vuelven a ser botones cortos, cada uno una sola vez."
        ]
      }
    },
    {
      "id": "2026-10-30-phone-polish-round-2",
      "date": "2026-10-30",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Tidier screens on phones",
        "ar": "شاشات أكثر ترتيبًا على الهواتف",
        "de-DE": "Aufgeräumtere Bildschirme auf dem Handy",
        "fr-FR": "Des écrans plus nets sur téléphone",
        "es-ES": "Pantallas más ordenadas en el móvil"
      },
      "items": {
        "en-US": [
          "When you are offline, a slim dark line at the top says so, and the page no longer drops down below it.",
          "The Assets network view now scrolls on a phone, and its buttons and key no longer overlap.",
          "Spacing and alignment fixes on asset details, the New asset form and the \"Needs a job?\" sheet."
        ],
        "ar": [
          "عندما تكون غير متصل، يظهر شريط داكن رفيع في الأعلى، ولم تعد الصفحة تنزاح إلى الأسفل.",
          "أصبح عرض شبكة الأصول قابلاً للتمرير على الهاتف، ولم تعد أزراره ومفتاحه متداخلة.",
          "تحسينات في المسافات والمحاذاة في تفاصيل الأصل ونموذج الأصل الجديد ونافذة \"هل يحتاج إلى مهمة؟\"."
        ],
        "de-DE": [
          "Wenn Sie offline sind, zeigt eine schmale dunkle Zeile oben das an, und die Seite rutscht nicht mehr nach unten.",
          "Die Netzwerkansicht unter Anlagen lässt sich auf dem Handy jetzt scrollen, Schaltflächen und Legende überlappen nicht mehr.",
          "Abstände und Ausrichtung verbessert in Anlagendetails, im Formular Neue Anlage und im Fenster \"Auftrag nötig?\"."
        ],
        "fr-FR": [
          "Hors ligne, une fine ligne sombre en haut l'indique, et la page ne descend plus en dessous.",
          "La vue réseau des équipements défile maintenant sur téléphone, et ses boutons et sa légende ne se chevauchent plus.",
          "Espacements et alignements corrigés dans le détail d'un équipement, le formulaire Nouvel équipement et la fenêtre \"Intervention nécessaire ?\"."
        ],
        "es-ES": [
          "Sin conexión, una línea oscura y fina arriba lo indica, y la página ya no se desplaza hacia abajo.",
          "La vista de red de Activos ahora se desplaza en el móvil, y sus botones y leyenda ya no se superponen.",
          "Ajustes de espaciado y alineación en el detalle del activo, el formulario Nuevo activo y la ventana \"¿Necesita un trabajo?\"."
        ]
      }
    },
    {
      "id": "2026-10-30-checklist-ai-or-manual",
      "date": "2026-10-30",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "New checklists ask: AI or by hand",
        "ar": "قوائم التحقق الجديدة تسألك: بالذكاء الاصطناعي أم يدويًا",
        "de-DE": "Neue Checklisten fragen: mit KI oder von Hand",
        "fr-FR": "Les nouvelles check-lists demandent : avec l'IA ou à la main",
        "es-ES": "Las nuevas listas de control preguntan: con IA o a mano"
      },
      "items": {
        "en-US": [
          "Creating a checklist now asks how to build it first: Generate with AI or Create manually. It works the same from Checklists, the + button, the planning sheet and a job, on phone, tablet and web."
        ],
        "ar": [
          "عند إنشاء قائمة تحقق يسألك التطبيق الآن أولًا عن طريقة إنشائها: إنشاء بالذكاء الاصطناعي أو إنشاء يدويًا. يعمل ذلك بالطريقة نفسها من قوائم التحقق وزر + ونافذة التخطيط والمهمة، على الهاتف والجهاز اللوحي والويب."
        ],
        "de-DE": [
          "Beim Erstellen einer Checkliste werden Sie jetzt zuerst gefragt, wie Sie sie aufbauen möchten: „Mit KI generieren“ oder „Manuell erstellen“. Das gilt überall gleich: Checklisten, die +-Schaltfläche, das Planungsfenster und ein Auftrag, auf Telefon, Tablet und im Web."
        ],
        "fr-FR": [
          "Créer une check-list vous demande maintenant d'abord comment la construire : « Générer avec l'IA » ou « Créer manuellement ». C'est pareil depuis Check-lists, le bouton +, la fenêtre de planification et une intervention, sur téléphone, tablette et web."
        ],
        "es-ES": [
          "Al crear una lista de control ahora se pregunta primero cómo crearla: «Generar con IA» o «Crear manualmente». Funciona igual desde Listas de control, el botón +, la ventana de planificación y un trabajo, en teléfono, tableta y web."
        ]
      }
    },
    {
      "id": "2026-10-30-manual-platform-alignment",
      "date": "2026-10-30",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Asset types and Assistant activity are now under Account on every device",
        "ar": "أنواع الأصول ونشاط المساعد الآن ضمن الحساب على كل جهاز",
        "de-DE": "Anlagentypen und Assistent-Aktivität jetzt auf jedem Gerät unter Konto",
        "fr-FR": "Types d’actifs et Activité de l’assistant sont maintenant dans Compte sur tous les appareils",
        "es-ES": "Tipos de activo y Actividad del asistente ya están en Cuenta en todos los dispositivos"
      },
      "items": {
        "en-US": [
          "Account → Workspace now lists Asset types and Assistant activity on phones and tablets too, not only on the web.",
          "Group rules now have their own entry in More on a phone and in the side menu on a tablet or computer.",
          "The user guide now gives the right place for every feature and says when something works only in the phone and tablet app or only on a tablet or computer."
        ],
        "ar": [
          "تعرض «الحساب ← مساحة العمل» الآن أنواع الأصول ونشاط المساعد على الهواتف والأجهزة اللوحية أيضًا، وليس على الويب فقط.",
          "أصبح لقواعد المجموعات الآن مدخل خاص في «المزيد» على الهاتف وفي القائمة الجانبية على الجهاز اللوحي أو الحاسوب.",
          "يذكر دليل المستخدم الآن المكان الصحيح لكل ميزة، ويوضح متى تعمل ميزة في تطبيق الهاتف والجهاز اللوحي فقط أو على الجهاز اللوحي والحاسوب فقط."
        ],
        "de-DE": [
          "Konto → Arbeitsbereich zeigt Anlagentypen und Assistent-Aktivität jetzt auch auf Telefon und Tablet, nicht nur im Web.",
          "Gruppenregeln haben jetzt einen eigenen Eintrag unter „Mehr“ auf dem Telefon und im Seitenmenü auf Tablet und Computer.",
          "Die Benutzeranleitung nennt jetzt für jede Funktion den richtigen Ort und sagt, wenn etwas nur in der App für Telefon und Tablet oder nur auf Tablet und Computer geht."
        ],
        "fr-FR": [
          "Compte → Espace de travail affiche maintenant Types d’actifs et Activité de l’assistant aussi sur téléphone et tablette, pas seulement sur le web.",
          "Les règles de groupe ont maintenant leur propre entrée dans « Plus » sur téléphone et dans le menu latéral sur tablette ou ordinateur.",
          "Le guide utilisateur indique maintenant le bon emplacement de chaque fonction et précise quand elle n’existe que dans l’application pour téléphone et tablette, ou seulement sur tablette et ordinateur."
        ],
        "es-ES": [
          "Cuenta → Espacio de trabajo muestra ahora Tipos de activo y Actividad del asistente también en teléfonos y tabletas, no solo en la web.",
          "Las reglas de grupo tienen ahora su propia entrada en «Más» en el teléfono y en el menú lateral en una tableta o un ordenador.",
          "La guía del usuario indica ahora el lugar correcto de cada función y avisa cuando algo solo funciona en la app para teléfono y tableta, o solo en una tableta o un ordenador."
        ]
      }
    },
    {
      "id": "2026-10-30-assistant-streaming-history",
      "date": "2026-10-30",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Assistant replies appear as they are written",
        "ar": "ردود المساعد تظهر أثناء كتابتها",
        "de-DE": "Antworten des Assistenten erscheinen beim Schreiben",
        "fr-FR": "Les réponses de l'assistant s'affichent pendant leur rédaction",
        "es-ES": "Las respuestas del asistente aparecen mientras se escriben"
      },
      "items": {
        "en-US": [
          "The assistant's reply now appears as it is written, and while it checks your records you see how many it has looked up.",
          "Job and site history now show changes made through the assistant, marked \"via the assistant\", with who confirmed them."
        ],
        "ar": [
          "يظهر رد المساعد الآن أثناء كتابته، وأثناء تحققه من سجلاتك ترى عدد ما بحث فيه.",
          "يعرض سجل المهام والمواقع الآن التغييرات التي تمت عبر المساعد، مع اسم من أكدها."
        ],
        "de-DE": [
          "Die Antwort des Assistenten erscheint jetzt beim Schreiben, und während er Ihre Daten prüft, sehen Sie, wie viele er schon abgerufen hat.",
          "Der Verlauf von Aufträgen und Standorten zeigt jetzt Änderungen über den Assistenten, mit der Person, die sie bestätigt hat."
        ],
        "fr-FR": [
          "La réponse de l'assistant s'affiche maintenant pendant sa rédaction, et pendant qu'il consulte vos données vous voyez combien il en a déjà vérifié.",
          "L'historique des interventions et des sites montre maintenant les modifications faites via l'assistant, avec la personne qui les a confirmées."
        ],
        "es-ES": [
          "La respuesta del asistente aparece ahora mientras se escribe, y mientras consulta tus registros ves cuántos ha revisado.",
          "El historial de trabajos y sedes muestra ahora los cambios hechos con el asistente, con quién los confirmó."
        ]
      }
    },
    {
      "id": "2026-10-30-assistant-context-memory",
      "date": "2026-10-30",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "The assistant knows what you selected, remembers, and works offline",
        "ar": "المساعد يعرف ما حددته ويتذكر ويعمل دون اتصال",
        "de-DE": "Der Assistent kennt Ihre Auswahl, merkt sich Dinge und arbeitet offline",
        "fr-FR": "L'assistant connaît votre sélection, retient et fonctionne hors ligne",
        "es-ES": "El asistente sabe qué has seleccionado, recuerda y funciona sin conexión"
      },
      "items": {
        "en-US": [
          "Tick assets in the list and ask the assistant about \"these\": it works on exactly the ones you selected.",
          "New: tell the assistant something to remember for the whole workspace. Everyone can see, change or forget these in Account > Workspace > Assistant activity.",
          "With no signal, your question waits and is sent when you are back online, and app guide articles that may answer it show straight away.",
          "Spoken replies and hands-free use arrive with the next app store update."
        ],
        "ar": [
          "حدد أصولًا في القائمة واسأل المساعد عن \"هذه\": يعمل على ما حددته بالضبط.",
          "جديد: أخبر المساعد بشيء يتذكره لمساحة العمل كلها. يمكن للجميع رؤيته أو تغييره أو نسيانه من الحساب > مساحة العمل > نشاط المساعد.",
          "بدون إشارة، ينتظر سؤالك ويُرسل عند عودتك إلى الاتصال، وتظهر فورًا مقالات دليل التطبيق التي قد تجيب عنه.",
          "الردود المنطوقة والاستخدام بدون اليدين تأتي مع التحديث القادم من متجر التطبيقات."
        ],
        "de-DE": [
          "Haken Sie Anlagen in der Liste an und fragen Sie den Assistenten nach „diesen“: Er arbeitet genau mit Ihrer Auswahl.",
          "Neu: Sagen Sie dem Assistenten etwas, das er sich für den ganzen Arbeitsbereich merken soll. Alle können das unter Konto > Arbeitsbereich > Assistent-Aktivität sehen, ändern oder vergessen.",
          "Ohne Empfang wartet Ihre Frage und wird gesendet, sobald Sie wieder online sind, und passende Artikel der App-Anleitung erscheinen sofort.",
          "Vorgelesene Antworten und Freihändig kommen mit dem nächsten App-Store-Update."
        ],
        "fr-FR": [
          "Cochez des actifs dans la liste et interrogez l'assistant sur « ceux-ci » : il travaille exactement sur votre sélection.",
          "Nouveau : dites à l'assistant quelque chose à retenir pour tout l'espace de travail. Tout le monde peut le voir, le modifier ou l'oublier dans Compte > Espace de travail > Activité de l'assistant.",
          "Sans réseau, votre question attend et part dès votre retour en ligne, et les articles du guide de l'app qui peuvent y répondre s'affichent tout de suite.",
          "Les réponses lues à voix haute et le mode mains libres arrivent avec la prochaine mise à jour de l'app sur les stores."
        ],
        "es-ES": [
          "Marca activos en la lista y pregunta al asistente por «estos»: trabaja exactamente con los que has seleccionado.",
          "Nuevo: dile al asistente algo que recordar para todo el espacio de trabajo. Todos pueden verlo, cambiarlo u olvidarlo en Cuenta > Espacio de trabajo > Actividad del asistente.",
          "Sin cobertura, tu pregunta espera y se envía cuando vuelves a estar en línea, y los artículos de la guía de la app que pueden responderla aparecen al momento.",
          "Las respuestas en voz alta y el modo manos libres llegan con la próxima actualización de la tienda de apps."
        ]
      }
    },
    {
      "id": "2026-10-30-assistant-insights",
      "date": "2026-10-30",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Insights and a weekly briefing in the assistant",
        "ar": "رؤى وملخص أسبوعي في المساعد",
        "de-DE": "Einblicke und ein Wochenüberblick im Assistenten",
        "fr-FR": "Analyses et point hebdomadaire dans l'assistant",
        "es-ES": "Análisis y resumen semanal en el asistente"
      },
      "items": {
        "en-US": [
          "Ask the assistant how things are going, for example \"How has on-time completion moved?\" or \"Which site cost the most this quarter?\". It answers from your records, with a small chart.",
          "Ask \"Why do we keep getting leaks at North Depot?\" and it shows the repeating pattern and the evidence behind it.",
          "New: \"This week\" at the top of the assistant, with your week at a glance and a few questions to ask. Hide it for the week or turn it off; turn it back on in Account > Workspace > Assistant activity.",
          "Ask for a report and the assistant opens the report screen ready to generate."
        ],
        "ar": [
          "اسأل المساعد عن سير الأمور، مثل \"كيف تطور الإنجاز في الموعد؟\" أو \"أي موقع كلف أكثر هذا الربع؟\". يجيب من سجلاتك مع رسم بياني صغير.",
          "اسأل \"لماذا تتكرر التسربات في North Depot؟\" فيعرض النمط المتكرر والدليل عليه.",
          "جديد: \"هذا الأسبوع\" أعلى المساعد، مع لمحة عن أسبوعك وبعض الأسئلة. أخفه لهذا الأسبوع أو أوقفه، وأعد تشغيله من الحساب > مساحة العمل > نشاط المساعد.",
          "اطلب تقريرًا فيفتح المساعد شاشة التقرير جاهزة للإنشاء."
        ],
        "de-DE": [
          "Fragen Sie den Assistenten, wie es läuft, etwa „Wie hat sich die Termintreue entwickelt?“ oder „Welcher Standort hat dieses Quartal am meisten gekostet?“. Er antwortet aus Ihren Daten, mit einem kleinen Diagramm.",
          "Fragen Sie „Warum haben wir am North Depot immer wieder Leckagen?“, und er zeigt das wiederkehrende Muster und die Belege dafür.",
          "Neu: „Diese Woche“ oben im Assistenten, mit Ihrer Woche auf einen Blick und einigen Fragen. Blenden Sie es für die Woche aus oder schalten Sie es aus; unter Konto > Arbeitsbereich > Assistent-Aktivität schalten Sie es wieder ein.",
          "Bitten Sie um einen Bericht, und der Assistent öffnet die Berichtsseite bereit zum Erstellen."
        ],
        "fr-FR": [
          "Demandez à l'assistant où en sont les choses, par exemple « Comment a évolué le respect des délais ? » ou « Quel site a coûté le plus ce trimestre ? ». Il répond d'après vos données, avec un petit graphique.",
          "Demandez « Pourquoi avons-nous sans cesse des fuites à North Depot ? » et il montre le schéma qui se répète et les éléments qui le justifient.",
          "Nouveau : « Cette semaine » en haut de l'assistant, avec votre semaine en un coup d'œil et quelques questions. Masquez-le pour la semaine ou désactivez-le ; réactivez-le dans Compte > Espace de travail > Activité de l'assistant.",
          "Demandez un rapport et l'assistant ouvre l'écran du rapport prêt à générer."
        ],
        "es-ES": [
          "Pregunta al asistente cómo van las cosas, por ejemplo «¿Cómo ha evolucionado el cumplimiento de plazos?» o «¿Qué sitio ha costado más este trimestre?». Responde con tus registros y un pequeño gráfico.",
          "Pregunta «¿Por qué seguimos teniendo fugas en North Depot?» y muestra el patrón que se repite y las pruebas.",
          "Nuevo: «Esta semana» arriba del asistente, con tu semana de un vistazo y algunas preguntas. Ocúltalo durante la semana o desactívalo; vuelve a activarlo en Cuenta > Espacio de trabajo > Actividad del asistente.",
          "Pide un informe y el asistente abre la pantalla del informe lista para generarlo."
        ]
      }
    },
    {
      "id": "2026-10-30-assistant-planning",
      "date": "2026-10-30",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Plan with the assistant",
        "ar": "خطط مع المساعد",
        "de-DE": "Mit dem Assistenten planen",
        "fr-FR": "Planifier avec l'assistant",
        "es-ES": "Planifica con el asistente"
      },
      "items": {
        "en-US": [
          "Ask the assistant \"Who is overloaded this week?\" or \"When can Sam fit in a 2 hour job?\" and it answers from working hours, time off and booked work.",
          "Ask it to plan someone's week, or to plan around someone being off, and it opens the planning board with the plan worked out. You see the changes and the travel saved, and nothing moves until you tap Apply.",
          "Ask \"How can we improve our inspections?\" for advice with the evidence behind it: duplicate schedules, high-risk assets with nothing scheduled, assets checked far more often than similar ones, look-alike checklists and contractors who often finish late. Some come with a one-tap fix you confirm."
        ],
        "ar": [
          "اسأل المساعد \"من لديه عمل أكثر من طاقته هذا الأسبوع؟\" أو \"متى يمكن لسام إنجاز مهمة مدتها ساعتان؟\" فيجيب استنادًا إلى ساعات العمل والإجازات والعمل المجدول.",
          "اطلب منه تخطيط أسبوع شخص ما، أو التخطيط حول غياب شخص، فيفتح لوحة التخطيط والخطة جاهزة. ترى التغييرات ووقت التنقل الموفَّر، ولا يتغير شيء حتى تضغط تطبيق.",
          "اسأل \"كيف نحسن عمليات الفحص لدينا؟\" لتحصل على نصائح مع الدليل عليها: جداول مكررة، وأصول عالية الخطورة بلا فحص مجدول، وأصول تُفحص أكثر بكثير من مثيلاتها، وقوائم تحقق متشابهة، ومقاولون يتأخرون غالبًا. بعضها يأتي مع إصلاح بضغطة واحدة تؤكده أنت."
        ],
        "de-DE": [
          "Fragen Sie den Assistenten „Wer ist diese Woche überlastet?“ oder „Wann hat Sam Zeit für einen 2-Stunden-Auftrag?“, und er antwortet anhand von Arbeitszeiten, Abwesenheiten und geplanter Arbeit.",
          "Bitten Sie ihn, die Woche einer Person zu planen oder um eine Abwesenheit herum zu planen, öffnet er die Planungstafel mit dem fertigen Plan. Sie sehen die Änderungen und die eingesparte Fahrzeit, und nichts ändert sich, bevor Sie auf „Übernehmen“ tippen.",
          "Fragen Sie „Wie verbessern wir unsere Inspektionen?“ für Ratschläge mit Belegen: doppelte Pläne, Anlagen mit hohem Risiko ohne geplante Inspektion, Anlagen, die viel öfter als ähnliche geprüft werden, ähnliche Checklisten und Auftragnehmer, die oft zu spät fertig werden. Manche kommen mit einer Korrektur per Fingertipp, die Sie bestätigen."
        ],
        "fr-FR": [
          "Demandez à l'assistant « Qui est surchargé cette semaine ? » ou « Quand Sam peut-il caser une intervention de 2 heures ? » : il répond d'après les horaires, les absences et le travail prévu.",
          "Demandez-lui de planifier la semaine de quelqu'un, ou de planifier autour d'une absence, et il ouvre le tableau de planification avec le plan calculé. Vous voyez les changements et le trajet économisé, et rien ne bouge tant que vous n'avez pas touché Appliquer.",
          "Demandez « Comment améliorer nos inspections ? » pour des conseils justifiés : plannings en double, équipements à risque élevé sans inspection prévue, équipements contrôlés bien plus souvent que leurs semblables, check-lists qui se ressemblent et prestataires souvent en retard. Certains viennent avec une correction en un geste, que vous confirmez."
        ],
        "es-ES": [
          "Pregunta al asistente «¿Quién está sobrecargado esta semana?» o «¿Cuándo puede Sam hacer un trabajo de 2 horas?» y responde a partir del horario, las ausencias y el trabajo programado.",
          "Pídele que planifique la semana de alguien, o que planifique en torno a una ausencia, y abre el tablero de planificación con el plan calculado. Ves los cambios y el desplazamiento ahorrado, y nada cambia hasta que tocas Aplicar.",
          "Pregunta «¿Cómo mejoramos nuestras inspecciones?» para recibir consejos con pruebas: programaciones duplicadas, activos de alto riesgo sin nada programado, activos revisados mucho más a menudo que otros parecidos, listas de verificación casi iguales y contratistas que suelen terminar tarde. Algunos traen un arreglo de un toque que tú confirmas."
        ]
      }
    },
    {
      "id": "2026-10-30-smarter-assistant",
      "date": "2026-10-30",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "A more capable assistant",
        "ar": "مساعد أكثر قدرة",
        "de-DE": "Ein fähigerer Assistent",
        "fr-FR": "Un assistant plus capable",
        "es-ES": "Un asistente más capaz"
      },
      "items": {
        "en-US": [
          "The assistant can now add and update assets, places, vehicles and sites, move inspections and change job details, as well as everything it did before. Ask for 20 rooms on a floor and it prepares them as one card.",
          "It looks things up in several steps before it answers, so it can compare assets or check a schedule first.",
          "Every change is still a card you confirm. You can edit the card before confirming, and Undo a change for 10 minutes afterwards.",
          "The assistant only does what you could do yourself: your permissions, your sites, your sign-in checks.",
          "New: Account > Workspace > Assistant activity lists every change made through the assistant. Owners and admins choose who may make changes through it.",
          "New: a camera button beside the microphone. Send a photo of a nameplate, a meter or some damage and the assistant reads it."
        ],
        "ar": [
          "يستطيع المساعد الآن إضافة الأصول والأماكن والمركبات والمواقع وتحديثها، ونقل الفحوصات وتغيير تفاصيل المهام، إضافة إلى كل ما كان يفعله سابقًا. اطلب 20 غرفة في طابق فيُعدّها في بطاقة واحدة.",
          "يبحث في عدة خطوات قبل أن يجيب، فيستطيع مقارنة الأصول أو مراجعة جدول أولًا.",
          "كل تغيير ما زال بطاقة تؤكدها أنت. يمكنك تعديل البطاقة قبل التأكيد، والتراجع عن التغيير خلال 10 دقائق.",
          "لا يفعل المساعد إلا ما تستطيع فعله بنفسك: صلاحياتك ومواقعك وتحققات تسجيل الدخول لديك.",
          "جديد: الحساب > مساحة العمل > نشاط المساعد يعرض كل تغيير تم عبر المساعد. يختار المالكون والمسؤولون من يمكنه إجراء التغييرات عبره.",
          "جديد: زر كاميرا بجانب الميكروفون. أرسل صورة للوحة بيانات أو عدّاد أو ضرر فيقرؤها المساعد."
        ],
        "de-DE": [
          "Der Assistent kann jetzt Anlagen, Orte, Fahrzeuge und Standorte anlegen und ändern, Inspektionen verschieben und Auftragsdetails ändern, zusätzlich zu allem Bisherigen. Bitten Sie um 20 Räume auf einer Etage, und er bereitet sie als eine Karte vor.",
          "Er sucht in mehreren Schritten, bevor er antwortet, und kann so Anlagen vergleichen oder zuerst einen Plan prüfen.",
          "Jede Änderung bleibt eine Karte, die Sie bestätigen. Sie können die Karte vor dem Bestätigen bearbeiten und eine Änderung 10 Minuten lang rückgängig machen.",
          "Der Assistent tut nur, was Sie selbst tun dürfen: Ihre Berechtigungen, Ihre Standorte, Ihre Anmeldeprüfungen.",
          "Neu: Konto > Arbeitsbereich > Assistent-Aktivität listet jede Änderung über den Assistenten. Inhaber und Admins legen fest, wer darüber Änderungen vornehmen darf.",
          "Neu: eine Kamerataste neben dem Mikrofon. Senden Sie ein Foto eines Typenschilds, Zählers oder Schadens, und der Assistent liest es."
        ],
        "fr-FR": [
          "L'assistant peut maintenant ajouter et modifier des équipements, lieux, véhicules et sites, déplacer des inspections et changer les détails d'une intervention, en plus de tout ce qu'il faisait déjà. Demandez 20 pièces sur un étage et il les prépare en une seule carte.",
          "Il cherche en plusieurs étapes avant de répondre, pour comparer des équipements ou vérifier un planning d'abord.",
          "Chaque changement reste une carte que vous confirmez. Vous pouvez modifier la carte avant de confirmer, et annuler un changement pendant 10 minutes.",
          "L'assistant ne fait que ce que vous pourriez faire vous-même : vos droits, vos sites, vos vérifications de connexion.",
          "Nouveau : Compte > Espace de travail > Activité de l'assistant liste chaque changement fait via l'assistant. Les propriétaires et admins choisissent qui peut faire des changements par lui.",
          "Nouveau : un bouton appareil photo à côté du micro. Envoyez une photo d'une plaque signalétique, d'un compteur ou d'un dégât et l'assistant la lit."
        ],
        "es-ES": [
          "El asistente ya puede añadir y actualizar activos, lugares, vehículos y sitios, mover inspecciones y cambiar detalles de trabajos, además de todo lo que hacía antes. Pide 20 salas en una planta y las prepara en una sola tarjeta.",
          "Busca en varios pasos antes de responder, así puede comparar activos o revisar una programación primero.",
          "Cada cambio sigue siendo una tarjeta que confirmas. Puedes editar la tarjeta antes de confirmar y deshacer un cambio durante 10 minutos.",
          "El asistente solo hace lo que tú podrías hacer: tus permisos, tus sitios, tus comprobaciones de inicio de sesión.",
          "Nuevo: Cuenta > Espacio de trabajo > Actividad del asistente muestra cada cambio hecho con el asistente. Propietarios y administradores eligen quién puede hacer cambios con él.",
          "Nuevo: un botón de cámara junto al micrófono. Envía una foto de una placa, un contador o un daño y el asistente la lee."
        ]
      }
    },
    {
      "id": "2026-10-29-request-a-feature",
      "date": "2026-10-29",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Request a feature",
        "ar": "طلب ميزة",
        "de-DE": "Funktionen wünschen",
        "fr-FR": "Demandez une fonctionnalité",
        "es-ES": "Solicita una función"
      },
      "items": {
        "en-US": [
          "Account > Help & support > Request a feature sends your idea straight to the AssetWRX team, with up to three screenshots.",
          "Your requests shows where each one is, from Under review to In the app now, with any reply from us. You get a notification when it changes.",
          "Ideas we're considering lets you vote for what comes next.",
          "You can also tell the assistant \"I wish the app could...\" and it drafts the request for you."
        ],
        "ar": [
          "الحساب > المساعدة والدعم > طلب ميزة يرسل فكرتك مباشرة إلى فريق AssetWRX، مع ما يصل إلى ثلاث لقطات شاشة.",
          "تعرض طلباتك أين وصل كل طلب، من قيد المراجعة إلى متاح في التطبيق الآن، مع أي رد منا. يصلك إشعار عند تغيّره.",
          "تتيح لك أفكار ندرسها التصويت لما سيأتي لاحقًا.",
          "يمكنك أيضًا أن تقول للمساعد «أتمنى لو يستطيع التطبيق...» فيصيغ الطلب لك."
        ],
        "de-DE": [
          "Konto > Hilfe & Support > Funktion wünschen schickt Ihre Idee direkt an das AssetWRX-Team, mit bis zu drei Bildschirmfotos.",
          "Ihre Wünsche zeigt, wo jeder steht, von Wird geprüft bis Jetzt in der App, mit unseren Antworten. Bei einer Änderung erhalten Sie eine Benachrichtigung.",
          "Unter Ideen, die wir prüfen, stimmen Sie ab, was als Nächstes kommt.",
          "Sie können dem Assistenten auch sagen: „Ich wünschte, die App könnte ...“, und er entwirft den Wunsch für Sie."
        ],
        "fr-FR": [
          "Compte > Aide et support > Demander une fonctionnalité envoie votre idée directement à l'équipe AssetWRX, avec jusqu'à trois captures d'écran.",
          "Vos demandes montre où en est chacune, d'En cours d'examen à Disponible dans l'app, avec nos réponses. Vous êtes notifié à chaque changement.",
          "Idées à l'étude vous permet de voter pour la suite.",
          "Vous pouvez aussi dire à l'assistant « J'aimerais que l'app puisse... » et il rédige la demande pour vous."
        ],
        "es-ES": [
          "Cuenta > Ayuda y soporte > Solicitar una función envía tu idea directamente al equipo de AssetWRX, con hasta tres capturas.",
          "Tus solicitudes muestra en qué punto está cada una, de En revisión a Ya en la app, con nuestras respuestas. Recibes una notificación cuando cambia.",
          "En Ideas que estamos valorando puedes votar lo que viene después.",
          "También puedes decirle al asistente «Ojalá la app pudiera...» y redacta la solicitud por ti."
        ]
      }
    },
    {
      "id": "2026-10-28-phone-spacing",
      "date": "2026-10-28",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Tidier screens on phones",
        "ar": "شاشات أكثر ترتيبًا على الهواتف",
        "de-DE": "Aufgeräumtere Bildschirme auf dem Telefon",
        "fr-FR": "Des écrans plus nets sur téléphone",
        "es-ES": "Pantallas más ordenadas en el móvil"
      },
      "items": {
        "en-US": [
          "Group rules, asset types, Set up a building, Add many and new rounds use less padding on phones, so fields and chips have room.",
          "The Places tree is more compact and lists floors and rooms in natural order (Room 2 before Room 10).",
          "An item's place shows correctly even before that place has loaded, instead of saying it is not inside anything.",
          "Small labels such as the bottom tabs and tile names are now easier to read."
        ],
        "ar": [
          "تستخدم قواعد المجموعات وأنواع الأصول وإعداد مبنى وإضافة عدة أصول والجولات الجديدة هوامش أصغر على الهواتف، فتتسع الحقول والأزرار.",
          "أصبحت شجرة الأماكن أكثر إحكامًا وتعرض الطوابق والغرف بترتيب طبيعي (الغرفة 2 قبل الغرفة 10).",
          "يظهر مكان العنصر بشكل صحيح حتى قبل تحميل ذلك المكان، بدلًا من القول إنه ليس داخل أي شيء.",
          "أصبحت التسميات الصغيرة مثل علامات التبويب السفلية وأسماء البطاقات أسهل قراءة."
        ],
        "de-DE": [
          "Gruppenregeln, Anlagentypen, Gebäude einrichten, Mehrere hinzufügen und neue Rundgänge haben auf dem Telefon weniger Innenabstand, damit Felder und Chips Platz haben.",
          "Der Orte-Baum ist kompakter und listet Etagen und Räume in natürlicher Reihenfolge (Raum 2 vor Raum 10).",
          "Der Ort eines Eintrags wird richtig angezeigt, auch bevor dieser Ort geladen ist, statt zu melden, er liege in keinem Ort.",
          "Kleine Beschriftungen wie die unteren Tabs und Kachelnamen sind jetzt besser lesbar."
        ],
        "fr-FR": [
          "Les règles de groupe, les types d'actifs, Configurer un bâtiment, Ajouter en lot et les nouvelles tournées ont moins de marges sur téléphone, pour laisser de la place aux champs et aux puces.",
          "L'arborescence des Lieux est plus compacte et classe étages et pièces dans l'ordre naturel (Pièce 2 avant Pièce 10).",
          "Le lieu d'un élément s'affiche correctement même avant que ce lieu soit chargé, au lieu d'indiquer qu'il n'est dans aucun lieu.",
          "Les petits libellés, comme les onglets du bas et les noms des tuiles, sont plus lisibles."
        ],
        "es-ES": [
          "Reglas de grupo, tipos de activos, Configurar un edificio, Añadir varios y las rondas nuevas usan menos márgenes en el móvil, para dejar sitio a campos y botones.",
          "El árbol de Lugares es más compacto y ordena plantas y salas de forma natural (Sala 2 antes que Sala 10).",
          "El lugar de un elemento se muestra bien incluso antes de que ese lugar se cargue, en vez de decir que no está dentro de nada.",
          "Las etiquetas pequeñas, como las pestañas inferiores y los nombres de los mosaicos, se leen mejor."
        ]
      }
    },
    {
      "id": "2026-10-28-fixes-after-places",
      "date": "2026-10-28",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Fixes for places, group rules and planning",
        "ar": "إصلاحات للأماكن وقواعد المجموعات والتخطيط",
        "de-DE": "Korrekturen für Orte, Gruppenregeln und Planung",
        "fr-FR": "Corrections pour les lieux, les règles de groupe et la planification",
        "es-ES": "Correcciones para lugares, reglas de grupo y planificación"
      },
      "items": {
        "en-US": [
          "Moving a building or floor now updates the group rule visits of everything inside it.",
          "Suggest a plan shows how long it has been working and has a Stop button.",
          "On the web, text typed into a field no longer disappears when the page scrolls.",
          "On iPhone, Guide me on an asset opens the tour's first screen again."
        ],
        "ar": [
          "نقل مبنى أو طابق يحدّث الآن زيارات قواعد المجموعات لكل ما بداخله.",
          "يعرض اقتراح خطة المدة التي استغرقها حتى الآن، ويحتوي على زر إيقاف.",
          "على الويب، لم يعد النص المكتوب في حقل يختفي عند تمرير الصفحة.",
          "على iPhone، يفتح «أرشدني» في الأصل الشاشة الأولى من الجولة مجددًا."
        ],
        "de-DE": [
          "Wenn Sie ein Gebäude oder Stockwerk verschieben, werden jetzt die Besuche aus Gruppenregeln für alles darin aktualisiert.",
          "Plan vorschlagen zeigt, wie lange es schon arbeitet, und hat eine Schaltfläche zum Stoppen.",
          "Im Web verschwindet in ein Feld eingegebener Text nicht mehr, wenn die Seite scrollt.",
          "Auf dem iPhone öffnet „Führe mich“ bei einem Asset wieder den ersten Schritt der Tour."
        ],
        "fr-FR": [
          "Déplacer un bâtiment ou un étage met désormais à jour les visites des règles de groupe pour tout ce qu'il contient.",
          "Suggérer un plan indique depuis combien de temps il travaille et propose un bouton Arrêter.",
          "Sur le web, le texte saisi dans un champ ne disparaît plus quand la page défile.",
          "Sur iPhone, « Guidez-moi » sur un équipement ouvre de nouveau le premier écran de la visite."
        ],
        "es-ES": [
          "Mover un edificio o una planta ahora actualiza las visitas de las reglas de grupo de todo lo que contiene.",
          "Sugerir un plan muestra cuánto tiempo lleva trabajando y tiene un botón Detener.",
          "En la web, el texto escrito en un campo ya no desaparece al desplazar la página.",
          "En iPhone, «Guíame» en un activo vuelve a abrir la primera pantalla del recorrido."
        ]
      }
    },
    {
      "id": "2026-10-28-places-and-custom-types",
      "date": "2026-10-28",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "Places, your own asset types and rounds",
        "ar": "الأماكن وأنواع الأصول الخاصة بك والجولات",
        "de-DE": "Orte, eigene Anlagentypen und Rundgänge",
        "fr-FR": "Lieux, vos propres types d'actifs et tournées",
        "es-ES": "Lugares, sus propios tipos de activos y rondas"
      },
      "items": {
        "en-US": [
          "Buildings, floors, rooms and other areas are now Places. The asset list splits into Places, Equipment and Vehicles, with a tree of what is inside each place.",
          "Create your own asset types, with their own fields and checklists.",
          "Group rules on the Checklists screen schedule every matching asset at once, for example every fire door in a building.",
          "Rounds: one job that walks a list of stops, each with its own checklist.",
          "Set up a building from a site's add menu creates its floors and rooms in one go, and shows how many billed assets it adds before it runs."
        ],
        "ar": [
          "أصبحت المباني والطوابق والغرف والمناطق الأخرى أماكن. تنقسم قائمة الأصول إلى الأماكن والمعدّات والمركبات، مع شجرة لما يوجد داخل كل مكان.",
          "أنشئ أنواع الأصول الخاصة بك، بحقولها وقوائم التحقق الخاصة بها.",
          "تُجدول قواعد المجموعات في شاشة قوائم التحقق كل الأصول المطابقة دفعة واحدة، مثل كل أبواب الحريق في مبنى.",
          "الجولات: عمل واحد يمرّ على قائمة محطات، لكل منها قائمة تحقق خاصة بها.",
          "ينشئ إعداد مبنى من قائمة الإضافة في الموقع طوابقه وغرفه دفعة واحدة، ويعرض عدد الأصول المحتسبة في الفاتورة التي سيضيفها قبل التنفيذ."
        ],
        "de-DE": [
          "Gebäude, Etagen, Räume und andere Bereiche sind jetzt Orte. Die Anlagenliste teilt sich in Orte, Ausrüstung und Fahrzeuge, mit einem Baum dessen, was in jedem Ort ist.",
          "Legen Sie eigene Anlagentypen an, mit eigenen Feldern und Checklisten.",
          "Gruppenregeln auf dem Bildschirm Checklisten planen alle passenden Anlagen auf einmal, zum Beispiel jede Brandschutztür in einem Gebäude.",
          "Rundgänge: ein Auftrag, der eine Liste von Halten abläuft, jeder mit eigener Checkliste.",
          "Ein Gebäude einrichten im Hinzufügen-Menü eines Standorts legt Etagen und Räume in einem Schritt an und zeigt vorher, wie viele abrechenbare Anlagen hinzukommen."
        ],
        "fr-FR": [
          "Les bâtiments, étages, pièces et autres zones sont désormais des Lieux. La liste des actifs se divise en Lieux, Équipements et Véhicules, avec l'arborescence de ce que contient chaque lieu.",
          "Créez vos propres types d'actifs, avec leurs propres champs et listes de contrôle.",
          "Les règles de groupe, dans l'écran Listes de contrôle, planifient d'un coup tous les actifs concernés, par exemple chaque porte coupe-feu d'un bâtiment.",
          "Tournées : une intervention qui parcourt une liste d'arrêts, chacun avec sa propre liste de contrôle.",
          "Configurer un bâtiment, depuis le menu d'ajout d'un site, crée ses étages et ses pièces en une fois et indique avant de lancer combien d'actifs facturés seront ajoutés."
        ],
        "es-ES": [
          "Los edificios, plantas, salas y otras zonas son ahora Lugares. La lista de activos se divide en Lugares, Equipos y Vehículos, con un árbol de lo que hay dentro de cada lugar.",
          "Cree sus propios tipos de activos, con sus propios campos y listas de verificación.",
          "Las reglas de grupo, en la pantalla Listas de verificación, programan de una vez todos los activos que coinciden, por ejemplo cada puerta cortafuegos de un edificio.",
          "Rondas: un trabajo que recorre una lista de paradas, cada una con su propia lista de verificación.",
          "Configurar un edificio, desde el menú de añadir de una sede, crea sus plantas y salas de una vez y muestra antes cuántos activos facturables añadirá."
        ]
      }
    },
    {
      "id": "2026-10-28-simpler-app",
      "date": "2026-10-28",
      "version": "2.0.1",
      "showInApp": true,
      "title": {
        "en-US": "A simpler, tidier app",
        "ar": "تطبيق أبسط وأكثر ترتيبًا",
        "de-DE": "Eine einfachere, aufgeräumtere App",
        "fr-FR": "Une application plus simple et plus claire",
        "es-ES": "Una aplicación más sencilla y ordenada"
      },
      "items": {
        "en-US": [
          "Home shows your four key numbers again: Needs you, At risk, Active and Due soon.",
          "Adding contacts from your phone is now one screen: search, tick and import.",
          "Questions before you delete or cancel something now open inside the app, with Keep as the safe answer.",
          "Cleaner spacing and easier-to-read text on asset, job and inspection pages.",
          "This What's new note, shown once after each update. Find past notes in Account › About."
        ],
        "ar": [
          "تعرض الصفحة الرئيسية أرقامك الأربعة الرئيسية مجددًا: يحتاج إليك، معرّض للخطر، نشطة، ويحل قريبًا.",
          "أصبحت إضافة جهات الاتصال من هاتفك شاشة واحدة: ابحث وحدّد ثم استورد.",
          "تظهر الأسئلة قبل الحذف أو الإلغاء الآن داخل التطبيق، مع \"إبقاء\" كخيار آمن.",
          "مسافات أوضح ونص أسهل قراءة في صفحات الأصول والمهام والفحوصات.",
          "ملاحظة \"ما الجديد\" هذه، تظهر مرة واحدة بعد كل تحديث. تجد الملاحظات السابقة في الحساب › حول."
        ],
        "de-DE": [
          "Die Startseite zeigt wieder Ihre vier wichtigsten Zahlen: Braucht Sie, Gefährdet, Aktiv und Bald fällig.",
          "Kontakte vom Telefon hinzufügen geht jetzt auf einem Bildschirm: suchen, ankreuzen, importieren.",
          "Rückfragen vor dem Löschen oder Abbrechen erscheinen jetzt in der App, mit Behalten als sicherer Antwort.",
          "Klarere Abstände und besser lesbarer Text auf Anlagen-, Auftrags- und Prüfungsseiten.",
          "Dieser Hinweis „Neuigkeiten“ erscheint einmal nach jedem Update. Frühere Hinweise finden Sie unter Konto › Info."
        ],
        "fr-FR": [
          "L'accueil affiche de nouveau vos quatre chiffres clés : Besoin de vous, À risque, Actifs et Échéance proche.",
          "Ajouter des contacts depuis votre téléphone tient désormais sur un seul écran : cherchez, cochez, importez.",
          "Les questions avant de supprimer ou d'annuler s'ouvrent désormais dans l'application, avec Conserver comme réponse sûre.",
          "Des espacements plus nets et un texte plus lisible sur les pages d'actifs, de travaux et d'inspections.",
          "Cette note Nouveautés, affichée une fois après chaque mise à jour. Retrouvez les notes précédentes dans Compte › À propos."
        ],
        "es-ES": [
          "Inicio vuelve a mostrar sus cuatro cifras clave: Requiere su atención, En riesgo, Activos y Vence pronto.",
          "Añadir contactos desde el teléfono es ahora una sola pantalla: busque, marque e importe.",
          "Las preguntas antes de eliminar o cancelar se abren ahora dentro de la aplicación, con Conservar como respuesta segura.",
          "Espaciado más limpio y texto más legible en las páginas de activos, trabajos e inspecciones.",
          "Esta nota de Novedades, que aparece una vez tras cada actualización. Encontrará las notas anteriores en Cuenta › Acerca de."
        ]
      }
    }
  ]
}
